webpackJsonp([207],Array(30).concat([
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_lib__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_format__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_valid__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_valid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_is_valid__);






var round = __WEBPACK_IMPORTED_MODULE_2__shared_lib__["a" /* default */].round;

var twoDecimals = round(2);

function convertDate(date) {
	if (!date) {
		return '';
	}

	var _date$split = date.split('/'),
	    _date$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
	    day = _date$split2[0],
	    month = _date$split2[1],
	    year = _date$split2[2];

	var result = year + '-' + month + '-' + day;
	var validDate = new Date(year, month, day);
	if (validDate.toString() === 'Invalid Date') {
		return '';
	}
	return result;
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

	var newDate = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(new Date(date), formatter);
	return newDate;
}

function formatPaymentDate(date) {
	var currentDate = new Date();
	var hours = currentDate.getHours();
	var minutes = currentDate.getMinutes();
	var seconds = currentDate.getSeconds();
	var formatedDate = date ? date + ' ' + hours + ':' + minutes + ':' + seconds : __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(new Date(), 'YYYY-MM-DD-HH-mm-ss');
	return formatedDate;
}

function generateBlob(data) {
	var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'application/pdf';

	return new Blob([data], { type: contentType });
}

function getLocalData(key) {
	return JSON.parse(localStorage.getItem("admin" + '::' + key));
}

function getLocalStorage() {
	return JSON.parse(localStorage.getItem('' + "admin"));
}

function getLocalToken() {
	return localStorage.getItem("admin" + '::token');
}

function removeLocalData(key) {
	return localStorage.removeItem("admin" + '::' + key);
}

function setLocalData(key, data) {
	return localStorage.setItem("admin" + '::' + key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

function showDownloadDialog(blob, name, extension, download) {
	var currentDate = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(new Date(), 'YYYY-MM-DD');
	var link = document.createElement('a');
	link.download = name + '_' + currentDate + '.' + extension;
	var href = window.URL.createObjectURL(blob);
	link.href = href;
	document.body.appendChild(link);
	if (!download) {
		var iframe = document.createElement('iframe');
		document.body.appendChild(iframe);
		iframe.style.display = 'none';
		iframe.src = href;
		iframe.onload = function () {
			setTimeout(function () {
				iframe.focus();
				iframe.contentWindow.print();
			}, 100);
		};
	} else {
		link.click();
	}
	document.body.removeChild(link);
	window.URL.revokeObjectURL(href);
}
function showDownloadDialogOld(blob, name, extension) {
	var currentDate = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(new Date(), 'YYYY-MM-DD');
	var link = document.createElement('a');
	link.download = name + '_' + currentDate + '.' + extension;
	var href = window.URL.createObjectURL(blob);
	link.href = href;
	document.body.appendChild(link);
	// link.click();
	window.open(link.href);
	// if (!download) {
	// 	const iframe = document.createElement('iframe');
	// 	document.body.appendChild(iframe);
	// 	iframe.style.display = 'none';
	// 	iframe.src = href;
	// 	iframe.onload = () => {
	// 		setTimeout(() => {
	// 			iframe.focus();
	// 			iframe.contentWindow.print();
	// 		}, 1);
	// 	};
	// } else {
	// }
	document.body.removeChild(link);
	window.URL.revokeObjectURL(href);
}

/* eslint-disable */
function debounce(func) {
	var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
	var immediate = arguments[2];

	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function isValidDate(date) {
	return __WEBPACK_IMPORTED_MODULE_4_date_fns_is_valid___default()(new Date(convertDate(date)));
}

function exactDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	var time = arguments[2];
	var splitBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'T';

	if (date) {
		var dateSplit = date.split(splitBy);
		var dateComplete = dateSplit[0].split('-');
		var timeComplete = dateSplit[1] ? dateSplit[1].split(':') : null;
		var year = dateComplete[0];
		var month = dateComplete[1] - 1;
		var day = dateComplete[2];
		var hour = timeComplete ? timeComplete[0] : null;
		var minutes = timeComplete ? timeComplete[1] : null;
		var seconds = timeComplete ? timeComplete[2].split('.')[0] : null;
		var newDate = !time || !timeComplete ? __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(new Date(year, month, day), formatter) : __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(new Date(year, month, day, hour, minutes, seconds), formatter);
		return newDate;
	}
	return '';
}

function quotesDistribution(amount, quotes) {
	var acc = 0;
	var quotesArr = [];
	for (var i = 0; i < quotes; i += 1) {
		var dif = amount - acc;
		var q = dif / (quotes - i);
		var qR = Math.ceil(q);
		acc += qR;
		quotesArr.push(qR);
	}
	if (acc > amount) {
		var lastQuote = quotesArr[quotes - 1];
		var excess = acc - amount;
		quotesArr[quotes - 1] = twoDecimals(lastQuote - excess);
	}
	return quotesArr;
}

function updateLocalStorage(key, data) {
	localStorage.removeItem(key);
	localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

function simpledownloadFile(url, name) {
	var isDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	var currentDate = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(new Date(), 'YYYY-MM-DD');
	var link = document.createElement('a');
	link.download = '' + name + (isDate ? '_' + currentDate : '');
	link.href = url;
	link.setAttribute('target', '_blank');
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

var methods = {
	convertDate: convertDate,
	debounce: debounce,
	exactDate: exactDate,
	formatDate: formatDate,
	formatPaymentDate: formatPaymentDate,
	generateBlob: generateBlob,
	getLocalData: getLocalData,
	getLocalStorage: getLocalStorage,
	getLocalToken: getLocalToken,
	isValidDate: isValidDate,
	removeLocalData: removeLocalData,
	quotesDistribution: quotesDistribution,
	setLocalData: setLocalData,
	showDownloadDialog: showDownloadDialog,
	showDownloadDialogOld: showDownloadDialogOld,
	updateLocalStorage: updateLocalStorage,
	simpledownloadFile: simpledownloadFile
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function created() {
	var _this = this;

	this.onToggleSnackBar();
	this.$bus.$on('is-loading', function (result) {
		_this.isLoading = result;
	});
}

function data() {
	return {
		isLoading: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	created: created,
	data: data
});

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_decimal_js_light__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_decimal_js_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_decimal_js_light__);








function priceListNewFormat(id, priceList, product, units) {
	var newPriceList = [];
	var defaultPriceList = {
		price: 0,
		ranges: [{ from: 0, to: 0, price: 0 }],
		units: {}
	};
	if (id) {
		newPriceList = priceList.map(function (price) {
			var newPrice = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, price);
			newPrice.showRanges = false;
			if (product.priceList[price.id]) {
				newPrice[price.id] = product.priceList[price.id];
				if (units) {
					newPrice[price.id].units = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, units);
				}
			} else {
				newPrice[price.id] = defaultPriceList;
			}
			return newPrice;
		});
	} else {
		newPriceList = priceList.map(function (list) {
			var newList = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, list);
			newList.showRanges = false;
			newList[list.id] = defaultPriceList;
			return newList;
		});
	}
	return newPriceList;
}
function getThisPropertysValue(property) {
	return function inner(Obj) {
		return Obj[property];
	};
}

function getPropertysValue(val) {
	return function inner(obj) {
		if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(obj[val]) === 'object') {
			return obj[val];
		}
		return obj[val];
	};
}

function buildMainObject() {
	for (var _len = arguments.length, obs = Array(_len), _key = 0; _key < _len; _key++) {
		obs[_key] = arguments[_key];
	}

	return function inner(id) {
		for (var _len2 = arguments.length, arg = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
			arg[_key2 - 1] = arguments[_key2];
		}

		var newObj = {};
		[].concat(obs).forEach(function (object) {
			var iden = object[id];
			newObj[iden] = {};
			[].concat(arg).forEach(function (el) {
				newObj[iden][el] = getPropertysValue(el)(object);
			});
		});
		return newObj;
	};
}
function formattingPriceList(collection) {
	var newObj = {};
	collection.forEach(function (p) {
		newObj[p.id] = p[p.id];
	});
	return newObj;
}

/* eslint-disable */
var compose = function compose() {
	for (var _len3 = arguments.length, fns = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		fns[_key3] = arguments[_key3];
	}

	return function () {
		for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
			args[_key4] = arguments[_key4];
		}

		return fns.reduceRight(function (res, fn) {
			return [fn.call.apply(fn, [null].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(res)))];
		}, args)[0];
	};
};

function setNewProperty(property, value) {
	return function p(obj) {
		var newObj = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, obj);
		newObj[property] = typeof value === 'function' ? value(obj) : value;
		return newObj;
	};
}

function setNewProp(property, v) {
	return function p(obj, index) {
		var newObj = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, obj);
		newObj[property] = typeof v === 'function' ? v(obj, index) : v;
		return newObj;
	};
}

function getRightPrice(quantity, priceList) {
	var range = priceList.ranges.find(function (r) {
		return quantity >= r.from && quantity <= r.to;
	});
	return range ? range.price : priceList.price;
}

function updatePrice(id) {
	return function p(product) {
		var newProduct = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, product);
		var quantity = newProduct.quantity;
		var priceList = newProduct.priceList[id];
		var price = getRightPrice(quantity, priceList);
		return setNewProperty('price', price)(newProduct);
	};
}

function decimals(decimal) {
	return function inner(value) {
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default()(value * Math.pow(10, decimal)) / Math.pow(10, decimal);
	};
}

function equitativeAmount(total, div) {
	return function inner(obj) {
		var newObj = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, obj);
		var ratio = Number(total / div);
		newObj = setNewProperty('paid', ratio)(newObj);
		return newObj;
	};
}

function distributeAmount(total, div, cards, note, detraction) {
	var ntc = cards ? cards.find(function (c) {
		return c.code === 'cntc';
	}) : null;
	var noteAmount = note ? note.amount : 0;
	var newTotal = ntc ? total - Number(note.amount) : total;
	var newDiv = ntc ? div - 1 : div;
	var makeLoop = newDiv !== 1;
	var ratio = makeLoop ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default()(Number(newTotal / newDiv)) : Number(newTotal / newDiv);
	return function inner(obj, index) {
		if (!obj.paid && !obj.edit) {
			if (makeLoop) {
				var diff = Number((newTotal - ratio * (newDiv - 1)).toFixed(2));
				var distributeRatio = index + 1 === newDiv ? diff : ratio;
				if (ntc && noteAmount > total) {
					return setNewProperty('paid', 0)(obj);
				}
				return setNewProperty('paid', distributeRatio)(obj);
			} else if (ntc && noteAmount > total) {
				return setNewProperty('paid', 0)(obj);
			}
			return setNewProperty('paid', Number(ratio.toFixed(2)))(obj);
		}
		return setNewProperty('paid', Number(obj.paid.toFixed(2)))(obj);
	};
}

function distributeAmountWithDetraction(total, div, cards, note, detraction) {
	var amountWithoutDetraction = getAmountDetraction(total);
	var realTotal = detraction ? total - amountWithoutDetraction : total;
	var ntc = cards ? cards.find(function (c) {
		return c.code === 'cntc';
	}) : null;
	var noteAmount = note ? note.amount : 0;
	var newTotal = ntc ? realTotal - Number(note.amount) : realTotal;
	var newDiv = ntc ? div - 1 : div;
	var makeLoop = newDiv !== 1;
	var ratio = makeLoop ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default()(Number(newTotal / newDiv)) : Number(newTotal / newDiv);
	return function inner(obj, index) {
		if (!obj.paid && !obj.edit) {
			if (makeLoop) {
				var diff = Number((newTotal - ratio * (newDiv - 1)).toFixed(2));
				var distributeRatio = index + 1 === newDiv ? diff : ratio;
				if (ntc && noteAmount > realTotal) {
					return setNewProperty('paid', 0)(obj);
				}
				return setNewProperty('paid', distributeRatio)(obj);
			} else if (ntc && noteAmount > realTotal) {
				return setNewProperty('paid', 0)(obj);
			}
			return setNewProperty('paid', Number(ratio.toFixed(2)))(obj);
		}
		return setNewProperty('paid', Number(obj.paid.toFixed(2)))(obj);
	};
}

function reduceCompose(fn2, fn1) {
	return function inner(list, value) {
		return fn2(list, fn1(value));
	};
}

function filteByEquality() {
	for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		args[_key5] = arguments[_key5];
	}

	var _ref = [].concat(args),
	    value = _ref[0],
	    props = _ref.slice(1);

	return function inner(list, obj) {
		var newList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(list));
		var newProps = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(props));
		newProps.forEach(function (v) {
			if (obj[value].toString() === v) {
				newList = newList.concat(obj);
			}
		});
		return newList;
	};
}

function filteByMajorTo() {
	for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
		args[_key6] = arguments[_key6];
	}

	var _ref2 = [].concat(args),
	    vale = _ref2[0],
	    props = _ref2.slice(1);

	return function inner(list, obj) {
		var newList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(list));
		var newProps = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(props));
		newProps.forEach(function (v) {
			if (Number(obj[value]) >= Number(v)) {
				newList = newList.concat(obj);
			}
		});
		return newList;
	};
}

function filterCollectionByEquality(val) {
	for (var _len7 = arguments.length, rest = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
		rest[_key7 - 1] = arguments[_key7];
	}

	var _ref3 = [].concat(rest),
	    prop1 = _ref3[0],
	    prop2 = _ref3[1];

	if (!prop2) {
		prop2 = prop1;
	}
	return reduceCompose(filteByEquality.apply(undefined, [prop2].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(val))), getPropertysValue(prop1));
}

function filterCollectionMajorAndEqualTo(val) {
	for (var _len8 = arguments.length, rest = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
		rest[_key8 - 1] = arguments[_key8];
	}

	var _ref4 = [].concat(rest),
	    prop1 = _ref4[0],
	    prop2 = _ref4[1];

	if (!prop2) {
		prop2 = prop1;
	}
	return reduceCompose(filteByMajorTo.apply(undefined, [prop2].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(val))), getPropertysValue(prop1));
}

function reduce(fn, col) {
	var acc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

	return col.reduce(fn, acc);
}

function filter(fn, col) {
	return col.filter(fn);
}

function removeItemFromArrayByIndex(index, arr) {
	return arr.reduce(function (list, item, ind) {
		var newList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(list));
		if (index === ind) {
			return newList;
		}
		return newList.concat(item);
	}, []);
}

function updateItemInCollection() {
	for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
		args[_key9] = arguments[_key9];
	}

	var _ref5 = [].concat(args),
	    item = _ref5[0],
	    matchProperty = _ref5[1],
	    propertyToUpdate = _ref5[2],
	    value = _ref5[3];

	var newValue = value === null || value === undefined ? item[propertyToUpdate] : value;
	return function inner(currentItem) {
		var newItem = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, currentItem);
		if (item[matchProperty] === currentItem[matchProperty]) {
			newItem = setNewProperty(propertyToUpdate, newValue)(newItem);
		}
		return newItem;
	};
}

function getAmountDetraction(amount) {
	var totalAmount = new __WEBPACK_IMPORTED_MODULE_6_decimal_js_light___default.a(amount);
	var dPercentage = new __WEBPACK_IMPORTED_MODULE_6_decimal_js_light___default.a(0.12);
	var dAmount = totalAmount.mul(dPercentage);
	return dAmount.toNumber().toFixed(2);
}

function getDeeper() {
	for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
		args[_key10] = arguments[_key10];
	}

	return function inner(item) {
		var newItem = null;
		if (item && item.length) {
			var _item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(item, 1);

			newItem = _item[0];
		} else {
			newItem = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, item);
		}
		args.forEach(function (el) {
			newItem = (newItem || {})[el];
		});
		return newItem;
	};
}

function getNewDeeper(props) {
	var args = props.split('.');
	return function inner(item) {
		var newItem = null;
		if (item.length) {
			var _item2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(item, 1);

			newItem = _item2[0];
		} else {
			newItem = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, item);
		}
		args.forEach(function (el) {
			newItem = (newItem || {})[el];
		});
		return newItem;
	};
}

/* eslint-disable prefer-const */
function equality() {
	for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
		args[_key11] = arguments[_key11];
	}

	var prop1 = args[0],
	    prop2 = args[1];

	if (!prop2) {
		prop2 = prop1;
	}
	return function inner(item) {
		if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(item)) === 'object') {
			return item[prop1] === (typeof prop2 === 'function' ? prop2.call() : prop2);
		}
		return item === (typeof prop1 === 'function' ? prop1.call() : prop1);
	};
}

function matchBetweenArraysOnlySale(collection1, collection2) {
	/*
 	TODO: FIXME:
 	Esta funcion solo se debe usar libreria Sale ya que lleva una validación especifica para los impuestos.
 	Debido a que el codePercentage 02(gratuito), hace referencia al code 02(Exonerado) en la
 	tabla de impuestos, esto genera que los TAXESAMOUNT, al enviar la venta se generen mal cuando se
 	envia 1 producto con impuesto "Gratuito" + "Exonerardo", duplicando el monto que se envia.
 	Estamos gregando una validación para que cuando se seleccione un inpuesto diferente a IGV, se tome el
 	campo de Code y no el CodePercentage.
 	Esta validación dejará de funcionar cuando se agreguen más selectores de impuestos en la
 	creación de producto.
 */
	var _collection = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(collection1, 2),
	    arr1 = _collection[0],
	    prop1 = _collection[1];

	var _collection2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(collection2, 2),
	    arr2 = _collection2[0],
	    prop2 = _collection2[1];

	var list = [];
	if (prop2) {
		arr1.forEach(function (a) {
			/*
   prop1 => codePercentage
   arr1 (Productos) -----
   	IGV => code: 01, codePercentage: 01
   	Gratuito => code: 05, codePercentage: 02
   	Exonerado => code: 01, codePercentage: 02
   	ICBPER => code: 07, codePercentage: 07
   	prop2 => code
   Tabla impuestos -----
   	IGV => code: 01
   	Gratuito => code: 05
   	Exonerado => code: 02
   	*/
			var isExonerated = a[prop1] === '02' && a.code === '01';
			var isIGV = a[prop1] === '01' && a.code === '01';
			var isIGVOrExo = isIGV || isExonerated;
			var val = isIGVOrExo ? a[prop1] : a.code;
			var match = find(equality(prop2, val), arr2);
			if (match) {
				list = list.concat(match);
			}
		});
	}
	if (arr1.every(function (a) {
		return typeof a === 'string' || typeof a === 'number';
	}) && arr2.every(function (a) {
		return typeof a === 'string' || typeof a === 'number';
	})) {
		arr1.forEach(function (a) {
			var match = arr2.find(function (b) {
				return a === b;
			});
			list = match ? list.concat(match) : list;
		});
	}
	return list;
}
function matchBetweenArrays(collection1, collection2) {
	var _collection3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(collection1, 2),
	    arr1 = _collection3[0],
	    prop1 = _collection3[1];

	var _collection4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(collection2, 2),
	    arr2 = _collection4[0],
	    prop2 = _collection4[1];

	var list = [];
	if (prop2) {
		arr1.forEach(function (a) {
			var val = a[prop1] || a;
			var match = find(equality(prop2, val), arr2);
			if (match) {
				list = list.concat(match);
			}
		});
	}
	if (arr1.every(function (a) {
		return typeof a === 'string' || typeof a === 'number';
	}) && arr2.every(function (a) {
		return typeof a === 'string' || typeof a === 'number';
	})) {
		arr1.forEach(function (a) {
			var match = arr2.find(function (b) {
				return a === b;
			});
			list = match ? list.concat(match) : list;
		});
	}
	return list;
}

function find(fn, col) {
	return col.find(fn);
}

function map(fn, col) {
	return col.map(fn);
}

function setNewPropertyByFunction(prop, fn) {
	var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	return function inner(item, index) {
		if (index === null || index === undefined) {
			if (item.length) {
				var _item3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(item, 2),
				    newItem = _item3[0],
				    newIndex = _item3[1];

				return [setNewProperty(prop, fn(newItem, newIndex))(newItem), newIndex];
			}
			return setNewProperty(prop, fn(item, index))(item);
		}
		if (flag) {
			return [setNewProperty(prop, fn(item, index))(item), index];
		}
		return setNewProperty(prop, fn(item, index))(item);
	};
}

function removeItemFromArray(prop, propValue) {
	return function inner(arr) {
		var newArr = arr || [];
		return newArr.reduce(function (list, item) {
			var newList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(list));
			if (propValue === item[prop]) {
				return newList;
			}
			return newList.concat(item);
		}, []);
	};
}

function createPropertyByOtherOne() {
	for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
		args[_key12] = arguments[_key12];
	}

	var prop1 = args[0],
	    prop2 = args[1];

	return function inner(item) {
		var newItem = {};
		if (item.length) {
			var _item4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(item, 1);

			newItem = _item4[0];
		} else {
			newItem = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, item);
		}
		newItem[prop1] = getPropertysValue(prop2)(newItem);
		return newItem;
	};
}

function updateAllItemInCollection(matchProp, row, collection) {
	return collection.reduce(function (list, item) {
		var order = row.order ? row.order === item.order : true;
		if (row[matchProp] === item[matchProp] && order) {
			return list.concat(row);
		}
		return list.concat(item);
	}, []);
}

function mergeObjects(obj1, obj2) {
	var newObj = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, obj1);
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj2).forEach(function (key) {
		if (!newObj[key]) {
			newObj[key] = obj2[key];
		}
	});
	return newObj;
}

function round(d) {
	return function inner(val) {
		return Number(val.toFixed(d));
	};
}

var isEmpty = function isEmpty(arg) {
	if (Array.isArray(arg)) {
		return arg.length === 0;
	}
	if ((typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(arg)) === 'object' && arg !== null) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(arg).length === 0;
	}
	if (typeof arg === 'string' || typeof arg === 'number') {
		return !arg;
	}
	return !arg;
};

var allAreTrue = function allAreTrue() {
	for (var _len13 = arguments.length, arg = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
		arg[_key13] = arguments[_key13];
	}

	return arg.every(function (a) {
		return a;
	});
};

/* harmony default export */ __webpack_exports__["a"] = ({
	allAreTrue: allAreTrue,
	buildMainObject: buildMainObject,
	createPropertyByOtherOne: createPropertyByOtherOne,
	compose: compose,
	decimals: decimals,
	distributeAmount: distributeAmount,
	distributeAmountWithDetraction: distributeAmountWithDetraction,
	equality: equality,
	equitativeAmount: equitativeAmount,
	filter: filter,
	filteByEquality: filteByEquality,
	filteByMajorTo: filteByMajorTo,
	filterCollectionByEquality: filterCollectionByEquality,
	filterCollectionMajorAndEqualTo: filterCollectionMajorAndEqualTo,
	find: find,
	formattingPriceList: formattingPriceList,
	getDeeper: getDeeper,
	getNewDeeper: getNewDeeper,
	getPropertysValue: getPropertysValue,
	getRightPrice: getRightPrice,
	getThisPropertysValue: getThisPropertysValue,
	isEmpty: isEmpty,
	map: map,
	matchBetweenArraysOnlySale: matchBetweenArraysOnlySale,
	matchBetweenArrays: matchBetweenArrays,
	mergeObjects: mergeObjects,
	priceListNewFormat: priceListNewFormat,
	reduce: reduce,
	reduceCompose: reduceCompose,
	removeItemFromArray: removeItemFromArray,
	removeItemFromArrayByIndex: removeItemFromArrayByIndex,
	round: round,
	setNewProp: setNewProp,
	setNewProperty: setNewProperty,
	setNewPropertyByFunction: setNewPropertyByFunction,
	updateAllItemInCollection: updateAllItemInCollection,
	updateItemInCollection: updateItemInCollection,
	updatePrice: updatePrice,
	getAmountDetraction: getAmountDetraction
});

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalize_css__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_authenticate__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_shortkey__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_the_mask__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__axios__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__http__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vuetify__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_global__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filters_global__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_global__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__router__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_helper__ = __webpack_require__(103);



var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var token, responseJapi, userJapi;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.$bus.$on('USER_INFO', function (user) {
							__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$userInfo = user;
						});
						this.$http.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpProductsRead.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpProduction.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpSales.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpSalesRead.interceptors.request.use(this.httpRequestInterceptor);
						this.$http.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpProductsRead.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpAcl.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpAcl.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpMiddleware.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpSales.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpSalesRead.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpProduction.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpProducts.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpProducts.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpQuipu.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpQuipu.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpAccount.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpAccount.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpReports.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpReports.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpFacSunat.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpFacSunat.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						token = __WEBPACK_IMPORTED_MODULE_19__shared_helper__["a" /* default */].getLocalToken();

						if (!token) {
							_context.next = 35;
							break;
						}

						_context.next = 28;
						return this.$httpSales.get('employees/current');

					case 28:
						responseJapi = _context.sent;
						userJapi = responseJapi.data;

						__WEBPACK_IMPORTED_MODULE_19__shared_helper__["a" /* default */].setLocalData('acl-id', userJapi.aclUserId);
						__WEBPACK_IMPORTED_MODULE_19__shared_helper__["a" /* default */].setLocalData('acl-code', userJapi.aclUserCode);
						__WEBPACK_IMPORTED_MODULE_19__shared_helper__["a" /* default */].setLocalData('admin-user', userJapi);
						this.$bus.$emit('USER_INFO', userJapi);
						this.$ga.set('userId', userJapi.aclUserCode);

					case 35:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

/* eslint-disable no-new */














// import registerGoogleMap from './google-map';







__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
	id: 'UA-119752111-1',
	autoTracking: {
		screenview: true
	},
	disableScriptLoader: true,
	sendHitTask: window.location.hostname === 'devquipu.netlify.com'
});
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_authenticate__["a" /* default */], {
	baseUrl: 'https://acl-old.tandia.pe/api',
	providers: {
		facebook: {
			clientId: "647291589118514",
			redirectUri: 'http://localhost:9001'
		}
	}
});

var userInfo = __WEBPACK_IMPORTED_MODULE_19__shared_helper__["a" /* default */].getLocalData('admin-user');
var router = Object(__WEBPACK_IMPORTED_MODULE_18__router__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_16__filters_global__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_13__vuetify__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_11__axios__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]);
// registerGoogleMap(Vue);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$today = __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default()(new Date(), 'YYYY-MM-DD');
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]();
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$imageUrl = '//old-betandia-admin.s3.amazonaws.com';
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$s3Static = Object({"NODE_ENV":"production","ENV_VAR":'production',"GTM_ID":'GTM-K5KNTT6',"ECOMMERCE_BASE_PATH":'https://tandiashop.com',"APP_NAME":'"japiadmin"',"ACL_URL":'https://acl-old.tandia.pe/api',"MIDDLEWARE_URL":'undefined',"PRODUCTION_URL":'https://production-old.tandia.pe',"PRODUCTS_URL":'https://products-old.tandia.pe',"PRODUCTS_READ_URL":'https://products-old.tandia.pe',"SALES_URL":'https://sales-old.tandia.pe',"SALES_READ_URL":'https://sales-old.tandia.pe',"SUNAT":'https://consult-old.tandia.pe/api/',"STORAGE_USER_KEY":"admin","S3_IMAGES_URL":'//old-betandia-admin.s3.amazonaws.com',"FIREBASE_URL":'https://japi-dev-8f250.firebaseio.com',"FIREBASE_KEY":'819b42b900791733a8403e72df2db2c828d117d0',"FIREBASE_PROJECT_ID":'japi-dev-8f250',"APP_CODE":'japiadmin',"COMPANY_LOGIN_LOGO":'https://old-betandia-admin.s3.amazonaws.com/logo-japi-blanco.svg',"COMPANY_LOGIN_LOGO_ECU":'undefined',"COMPANY_LOGIN_TITLE":'TANDIA',"COMPANY_LOGIN_BACKGROUND":'https://old-betandia-admin.s3.amazonaws.com/login-banner.jpg',"COMPANY_LOGIN_BACKGROUND_ECU":'undefined',"COMPANY_FAVICON":'/static/img/icons/android-icon-36x36.png',"COUNTRY_CODE":'PER',"FACTURACION_SUNAT_URL":'https://fact-old.tandia.pe',"API_PRODUCTS":'https://inventories-old.tandia.pe',"API_QUIPU":'undefined',"API_ACCOUNT":'undefined',"API_REPORTS":'https://report-old.tandia.pe',"API_EXCEL":'https://excel-old.tandia.pe',"VERONICA_API":'undefined',"GOOGLE_SEARCH_PLACE":'undefined',"FACEBOOK_API_KEY":"647291589118514","PHONE_CHANGE_PASSWORD":+51924891210}).S3_STATIC;
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$userInfo = userInfo;
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_17__mixins_global__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]({
	created: created,
	el: '#app',
	methods: {
		httpRequestInterceptor: __WEBPACK_IMPORTED_MODULE_12__http__["a" /* httpRequestInterceptor */],
		httpResponseInterceptor: __WEBPACK_IMPORTED_MODULE_12__http__["b" /* httpResponseInterceptor */],
		httpResponseSuccessInterceptor: __WEBPACK_IMPORTED_MODULE_12__http__["c" /* httpResponseSuccessInterceptor */]
	},
	router: router,
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_10__App__["a" /* default */]);
	}
});

/***/ }),
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2654c516_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(277);
function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var normalizeComponent = __webpack_require__(205)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2654c516_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view',{attrs:{"name":"login"}}),_vm._v(" "),_c('v-content',{class:{ 'pa-0' : _vm.$route.name === 'login' }},[(_vm.isLoading)?_c('v-progress-linear',{staticClass:"progress-bar",attrs:{"indeterminate":_vm.isLoading}}):_vm._e(),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbar.timeout,"color":_vm.snackbar.color,"top":true,"right":true},model:{value:(_vm.snackbar.isVisible),callback:function ($$v) {_vm.$set(_vm.snackbar, "isVisible", $$v)},expression:"snackbar.isVisible"}},[_c('p',{staticClass:"ma-0",domProps:{"innerHTML":_vm._s(_vm.snackbar.text)}}),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.snackbar.isVisible = false}}},[_vm._v("Cerrar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var aclInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://acl-old.tandia.pe/api'
});

var middlewareInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'undefined'
});

var productionInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://production-old.tandia.pe'
});

var productsInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://products-old.tandia.pe'
});

var productsReadInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://products-old.tandia.pe'
});

var salesInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://sales-old.tandia.pe'
});

var salesReadInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://sales-old.tandia.pe'
});

var sunatInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://consult-old.tandia.pe/api/'
});

var facturacionInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://fact-old.tandia.pe'
});

var quipuInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://inventories-old.tandia.pe'
});

var motorInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'undefined'
});

var accountInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'undefined'
});

var fakeInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://reqres.in/api'
});

var reportsInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://report-old.tandia.pe'
});

// const googleInstance = axios.create({
// 	baseURL: process.env.GOOGLE_SEARCH_PLACE,
// });
var excelApiService = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://excel-old.tandia.pe'
});

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	/* eslint-disable no-param-reassign */
	Vue.prototype.$http = productsInstance;
	Vue.prototype.$httpProductsRead = productsReadInstance;
	Vue.prototype.$httpAcl = aclInstance;
	Vue.prototype.$httpMiddleware = middlewareInstance;
	Vue.prototype.$httpProduction = productionInstance;
	Vue.prototype.$httpSales = salesInstance;
	Vue.prototype.$httpSalesRead = salesReadInstance;
	Vue.prototype.$httpSunat = sunatInstance;
	Vue.prototype.$httpFacSunat = facturacionInstance;
	Vue.prototype.$httpProducts = quipuInstance;
	Vue.prototype.$httpQuipu = motorInstance;
	Vue.prototype.$httpAccount = accountInstance;
	Vue.prototype.$httpFake = fakeInstance;
	Vue.prototype.$httpReports = reportsInstance;
	// Vue.prototype.$httpSearchGoogle = googleInstance;
	Vue.prototype.$httpExcelApiService = excelApiService;
});

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = httpRequestInterceptor;
/* harmony export (immutable) */ __webpack_exports__["c"] = httpResponseSuccessInterceptor;
/* harmony export (immutable) */ __webpack_exports__["b"] = httpResponseInterceptor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


function httpRequestInterceptor(config) {
	var token = window.localStorage.getItem("admin" + '::token');
	var headers = config.headers;
	if (token) {
		headers.common.Authorization = 'Bearer ' + token;
		this.$bus.$emit('is-loading', true);
	} else {
		this.goTo('login');
	}
	return config;
}

function httpResponseSuccessInterceptor(response) {
	this.$bus.$emit('is-loading', false);
	return response;
}

function httpResponseInterceptor(error) {
	this.$bus.$emit('is-loading', false);

	var _ref = error.response || {},
	    status = _ref.status;

	var loginRoute = 'login';
	if (status === 401) {
		if (error.response.data.code === 1008) {
			this.showGenericError('Usuario y/o contraseña incorrecta, vuelva a intentarlo');
		} else if (error.response.data.message === 'USER_WITH_PREVIOUS_CONNECTION') {
			this.showGenericError('Ya existe una sesión activa con el usuario ingresado.');
		} else {
			this.showNotification('Su sesión ha expirado o alguien más ha ingresado con su cuenta.');
			// llamare aqui el logout manual
			var token = window.localStorage.getItem("admin" + '::token');
			if (token !== undefined && token != null && token !== '') {
				window.localStorage.clear();
				/* this.$httpAcl.post('logout', {}, {
    	headers: {
    		authorization: `Bearer ${token}`,
    	},
    }); */
				window.localStorage.setItem("admin" + '::' + 'date-close-notify-expired-plan', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(null));
				window.localStorage.setItem("admin" + '::' + 'expiration-date', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(null));
				window.localStorage.setItem("admin" + '::' + 'storage-expiration-date', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(null));
				this.goTo(loginRoute);
			}
		}
	} else if (status === 403) {
		this.showNotification('No tiene suficientes permisos para realizar esta acción');
	} else if (status === 500) {
		this.showGenericError();
	}
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
}

/***/ }),
/* 296 */,
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_directives__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_directives___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_directives__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_Vuetify__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_Vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_Vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VAlert__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VApp__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VStepper__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VSwitch__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VProgressCircular__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VProgressCircular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VProgressCircular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VPagination__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VPagination__);








































/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.use(__WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_Vuetify___default.a, {
		components: {
			VAlert: __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VAlert___default.a,
			VApp: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VApp___default.a,
			VBtn: __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default.a,
			VBtnToggle: __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle___default.a,
			VCheckbox: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox___default.a,
			VChip: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip___default.a,
			VCard: __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard___default.a,
			VDataIterator: __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VDataIterator___default.a,
			VDatePicker: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDatePicker___default.a,
			VDialog: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDialog___default.a,
			VDivider: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDivider___default.a,
			VForm: __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VForm___default.a,
			VGrid: __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VGrid___default.a,
			VIcon: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VIcon___default.a,
			VList: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VList___default.a,
			VMenu: __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VMenu___default.a,
			VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VNavigationDrawer___default.a,
			VRadioGroup: __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VRadioGroup___default.a,
			VSelect: __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSelect___default.a,
			VSlider: __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSlider___default.a,
			VSnackbar: __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSnackbar___default.a,
			VSubheader: __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader___default.a,
			VTextField: __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VTextField___default.a,
			VTimePicker: __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTimePicker___default.a,
			VToolbar: __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VToolbar___default.a,
			VTooltip: __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTooltip___default.a,
			transitions: __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_transitions___default.a,
			VExpansionPanel: __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VExpansionPanel___default.a,
			VDataTable: __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VDataTable___default.a,
			VProgressLinear: __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VProgressLinear___default.a,
			VTabs: __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs___default.a,
			VStepper: __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VStepper___default.a,
			VSwitch: __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VSwitch___default.a,
			VProgressCircular: __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VProgressCircular___default.a,
			VPagination: __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VPagination___default.a
		},
		theme: {
			primary: '#5765D9',
			secondary: '#818CB4',
			accent: '#005CAF',
			error: '#FF5253',
			info: '#2DB6F5',
			success: '#4DC68C',
			warning: '#FFB74C',
			pink: '#fe6b7d',
			tab: '#255e70',
			slide: '#37abd0',
			lightBlue: '#44b4e5',
			yellowFav: '#efce4a',
			buttonLogin: '#02979b',
			buttonCenter: '#1f87e5',
			baseText: '4a4a4a'
		},
		directives: {
			Scroll: __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_directives__["Scroll"]
		}
	});
});

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */,
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */,
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */,
/* 328 */,
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */,
/* 339 */,
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */,
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */,
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */,
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */,
/* 376 */,
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */,
/* 380 */,
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */,
/* 398 */,
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */,
/* 406 */,
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */,
/* 436 */,
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */,
/* 454 */,
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(81);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-date-select', function () {
  return __webpack_require__.e/* import() */(183).then(__webpack_require__.bind(null, 685));
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-select', function () {
  return __webpack_require__.e/* import() */(181).then(__webpack_require__.bind(null, 684));
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-input-text', function () {
  return __webpack_require__.e/* import() */(182).then(__webpack_require__.bind(null, 687));
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-tooltip-button', function () {
  return __webpack_require__.e/* import() */(198).then(__webpack_require__.bind(null, 686));
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-date-mask', function () {
  return __webpack_require__.e/* import() */(184).then(__webpack_require__.bind(null, 688));
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('layouts-slide-container', function () {
  return __webpack_require__.e/* import() */(180).then(__webpack_require__.bind(null, 689));
});

/***/ }),
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(81);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('jailai', {
	update: function update(el, binding) {
		if (binding.value && binding.oldValue !== binding.value) {
			el.classList.add('jailai');
			setTimeout(function () {
				el.classList.remove('jailai');
			}, 3000);
		}
	}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('scroll');

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);



function abs(value) {
	var newValue = Number(value);
	if (newValue > 0 && newValue < 0.1 || newValue < 0 && newValue > -0.1) {
		return Math.abs(newValue);
	}
	return newValue;
}

function round(value) {
	var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

	var newValue = Number(value);
	return newValue ? newValue.toFixed(decimals) : 0;
}

function limitTo(value) {
	var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

	if (value && value.length > length) {
		var cutText = value.substring(0, length);
		return cutText + '...';
	}
	return value;
}

function lowerCase(value) {
	var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'toLowerCase';

	var textTransform = value[transform]();
	return textTransform;
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

	var newDate = date ? __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(new Date(date), formatter) : null;
	return newDate;
}

function formatPaymentDate(date) {
	var _date$split = date.split('.'),
	    _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 1),
	    paymentDateBase = _date$split2[0];

	var _paymentDateBase$spli = paymentDateBase.split('T'),
	    _paymentDateBase$spli2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_paymentDateBase$spli, 2),
	    paymentDate = _paymentDateBase$spli2[0],
	    paymentHours = _paymentDateBase$spli2[1];

	return paymentDate + ' ' + paymentHours;
}

function formatNumber(value) {
	var sameValue = value === Math.floor(value);
	if (!sameValue) {
		return round(value);
	}
	return value;
}

function exactDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	var time = arguments[2];
	var splitBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'T';

	if (date) {
		var dateSplit = date.split(splitBy);
		var dateComplete = dateSplit[0].split('-');
		var timeComplete = dateSplit[1] ? dateSplit[1].split(':') : null;
		var year = dateComplete[0];
		var month = dateComplete[1] - 1;
		var day = dateComplete[2];
		var hour = timeComplete ? timeComplete[0] : null;
		var minutes = timeComplete ? timeComplete[1] : null;
		var seconds = timeComplete ? timeComplete[2].split('.')[0] : null;
		var newDate = !time || !timeComplete ? __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(new Date(year, month, day), formatter) : __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(new Date(year, month, day, hour, minutes, seconds), formatter);
		return newDate;
	}
	return '';
}

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.filter('round', round);
	Vue.filter('limitTo', limitTo);
	Vue.filter('formatDate', formatDate);
	Vue.filter('lowerCase', lowerCase);
	Vue.filter('formatNumber', formatNumber);
	Vue.filter('formatPaymentDate', formatPaymentDate);
	Vue.filter('abs', abs);
	Vue.filter('exactDate', exactDate);
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_flag_type__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_helper__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__events__ = __webpack_require__(583);






var exportTable = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(columns, rows, name) {
		var code, model, response, blob;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						code = 'xlsx';
						model = {
							code: code,
							columns: columns,
							rows: rows
						};

						if (!(rows.length > 0)) {
							_context.next = 16;
							break;
						}

						_context.prev = 3;
						_context.next = 6;
						return this.$httpSales.post('reports', model, { responseType: 'blob' });

					case 6:
						response = _context.sent;
						blob = __WEBPACK_IMPORTED_MODULE_7__shared_helper__["a" /* default */].generateBlob(response.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

						__WEBPACK_IMPORTED_MODULE_7__shared_helper__["a" /* default */].showDownloadDialog(blob, name, code);
						_context.next = 14;
						break;

					case 11:
						_context.prev = 11;
						_context.t0 = _context['catch'](3);

						this.showNotification('Ocurrió un error en el servidor al intentar exportar la data', 'error');

					case 14:
						_context.next = 17;
						break;

					case 16:
						this.showNotification('Debe seleccionar una o más filas para exportar.', 'warning');

					case 17:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[3, 11]]);
	}));

	return function exportTable(_x3, _x4, _x5) {
		return _ref.apply(this, arguments);
	};
}();

var onEmitDocumentWithFormat = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(code, originName, params) {
		var isGenericReport = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
		var module = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'ventas';
		var extension = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'xlsx';
		var onlyName = arguments[6];

		var now, _$userInfo, name, lastname, documentData, url;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						this.loadingExcel = true;
						now = Object(__WEBPACK_IMPORTED_MODULE_5_date_fns__["format"])(new Date(), 'YYYY_MM_DD_HH_mm_ss');
						_$userInfo = this.$userInfo, name = _$userInfo.name, lastname = _$userInfo.lastname;
						documentData = {
							filename: onlyName ? originName : '' + originName + now,
							extension: extension,
							comment: originName + ' generado por ' + name + ' ' + lastname,
							module: isGenericReport ? module : undefined,
							params: params
						};
						url = (isGenericReport ? 'generic' : 'documents') + '/' + code;
						_context2.next = 7;
						return this.$httpReports.post(url, documentData);

					case 7:
						this.showExcelGenerateMessage();

					case 8:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function onEmitDocumentWithFormat(_x8, _x9, _x10) {
		return _ref2.apply(this, arguments);
	};
}();

var onEmitExcel = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(code, originName, params) {
		var isGenericReport = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
		var module = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'ventas';
		var isDate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

		var now, _$userInfo2, name, lastname, documentData, url;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						this.loadingExcel = true;
						now = Object(__WEBPACK_IMPORTED_MODULE_5_date_fns__["format"])(new Date(), 'YYYY_MM_DD_HH_mm_ss');
						_$userInfo2 = this.$userInfo, name = _$userInfo2.name, lastname = _$userInfo2.lastname;
						documentData = {
							filename: '' + originName + (isDate ? now : ''),
							extension: 'xlsx',
							comment: originName + ' generado por ' + name + ' ' + lastname,
							module: isGenericReport ? module : undefined,
							params: params
						};
						url = (isGenericReport ? 'generic' : 'documents') + '/' + code;
						_context3.next = 7;
						return this.$httpReports.post(url, documentData);

					case 7:
						this.showExcelGenerateMessage();

					case 8:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function onEmitExcel(_x14, _x15, _x16) {
		return _ref3.apply(this, arguments);
	};
}();

var onAmortizationList = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(originName, params) {
		var now, _$userInfo3, name, lastname, documentData, hrefTag, msg;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						now = Object(__WEBPACK_IMPORTED_MODULE_5_date_fns__["format"])(new Date(), 'YYYY_MM_HH_mm_ss');
						_$userInfo3 = this.$userInfo, name = _$userInfo3.name, lastname = _$userInfo3.lastname;
						documentData = {
							filename: '' + originName + now,
							extension: 'pdf',
							comment: originName + ' generado por ' + name + ' ' + lastname,
							params: params
						};
						_context4.next = 5;
						return this.$httpReports.post('documents/list-document-account-status-pdf', documentData);

					case 5:
						hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
						msg = 'El reporte est\xE1 siendo generado, puede revisar su estado en la secci\xF3n de ' + hrefTag;

						this.showNotification(msg, 'green', 20000);

					case 8:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function onAmortizationList(_x20, _x21) {
		return _ref4.apply(this, arguments);
	};
}();

var onPayableList = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(originName, params) {
		var now, _$userInfo4, name, lastname, documentData, hrefTag, msg;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						now = Object(__WEBPACK_IMPORTED_MODULE_5_date_fns__["format"])(new Date(), 'YYYY_MM_HH_mm_ss');
						_$userInfo4 = this.$userInfo, name = _$userInfo4.name, lastname = _$userInfo4.lastname;
						documentData = {
							filename: '' + originName + now,
							extension: 'pdf',
							comment: originName + ' generado por ' + name + ' ' + lastname,
							params: params
						};
						_context5.next = 5;
						return this.$httpReports.post('documents/list-document-account-status-pdf', documentData);

					case 5:
						hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
						msg = 'El reporte est\xE1 siendo generado, puede revisar su estado en la secci\xF3n de ' + hrefTag;

						this.showNotification(msg, 'green', 20000);

					case 8:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this);
	}));

	return function onPayableList(_x22, _x23) {
		return _ref5.apply(this, arguments);
	};
}();

var onProductList = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(originName, params) {
		var now, _$userInfo5, name, lastname, documentData, hrefTag, msg;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						now = Object(__WEBPACK_IMPORTED_MODULE_5_date_fns__["format"])(new Date(), 'YYYY_MM_HH_mm_ss');
						_$userInfo5 = this.$userInfo, name = _$userInfo5.name, lastname = _$userInfo5.lastname;
						documentData = {
							filename: '' + originName + now,
							extension: 'pdf',
							comment: originName + ' generado por ' + name + ' ' + lastname,
							params: params
						};
						_context6.next = 5;
						return this.$httpReports.post('documents/list-products-pdf', documentData);

					case 5:
						hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
						msg = 'El reporte de productos est\xE1 siendo generado, puede revisar su estado en la secci\xF3n de ' + hrefTag;

						this.showNotification(msg, 'green', 20000);

					case 8:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this);
	}));

	return function onProductList(_x24, _x25) {
		return _ref6.apply(this, arguments);
	};
}();

var onReportSale = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(params) {
		var now, _$userInfo6, name, lastname, documentData, hrefTag, msg;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
			while (1) {
				switch (_context7.prev = _context7.next) {
					case 0:
						now = Object(__WEBPACK_IMPORTED_MODULE_5_date_fns__["format"])(new Date(), 'YYYY_MM_DD_HH_mm_ss');
						_$userInfo6 = this.$userInfo, name = _$userInfo6.name, lastname = _$userInfo6.lastname;
						documentData = {
							filename: 'Reporte_Lista_de_ventas_pdf ' + now,
							extension: 'pdf',
							comment: 'Reporte_Lista_de_ventas_pdf generado por ' + name + ' ' + lastname,
							params: params
						};
						_context7.next = 5;
						return this.$httpReports.post('documents/list-document-sale-pdf', documentData);

					case 5:
						hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
						msg = 'El reporte de ventas est\xE1 siendo generado, puede revisar su estado en la secci\xF3n de ' + hrefTag;

						this.showNotification(msg, 'green', 20000);

					case 8:
					case 'end':
						return _context7.stop();
				}
			}
		}, _callee7, this);
	}));

	return function onReportSale(_x26) {
		return _ref7.apply(this, arguments);
	};
}();

var onReportSaleCommissions = function () {
	var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(params) {
		var now, _$userInfo7, name, lastname, documentData, hrefTag, msg;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
			while (1) {
				switch (_context8.prev = _context8.next) {
					case 0:
						now = Object(__WEBPACK_IMPORTED_MODULE_5_date_fns__["format"])(new Date(), 'YYYY_MM_DD_HH_mm_ss');
						_$userInfo7 = this.$userInfo, name = _$userInfo7.name, lastname = _$userInfo7.lastname;
						documentData = {
							filename: 'Reporte_Comisiones_de_ventas_pdf ' + now,
							extension: 'pdf',
							comment: 'Reporte_Comisiones_de_ventas_pdf generado por ' + name + ' ' + lastname,
							params: params
						};
						_context8.next = 5;
						return this.$httpReports.post('documents/list-commission-sale-pdf', documentData);

					case 5:
						hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
						msg = 'El reporte de ventas est\xE1 siendo generado, puede revisar su estado en la secci\xF3n de ' + hrefTag;

						this.showNotification(msg, 'green', 20000);

					case 8:
					case 'end':
						return _context8.stop();
				}
			}
		}, _callee8, this);
	}));

	return function onReportSaleCommissions(_x30) {
		return _ref8.apply(this, arguments);
	};
}();

var loadTypePerson = function () {
	var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
		var _ref10;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
			while (1) {
				switch (_context9.prev = _context9.next) {
					case 0:
						_context9.next = 2;
						return this.$httpSales.get('type-person');

					case 2:
						_ref10 = _context9.sent;
						this.personTypes = _ref10.data;

					case 4:
					case 'end':
						return _context9.stop();
				}
			}
		}, _callee9, this);
	}));

	return function loadTypePerson() {
		return _ref9.apply(this, arguments);
	};
}();






function data() {
	return {
		languages: {
			es: {
				id: 'es',
				name: 'Español'
			},
			en: {
				id: 'en',
				name: 'English'
			}
		},
		actionsToHelp: [],
		limit: 20,
		loadingExcel: false,
		snackbar: {
			text: '',
			isVisible: false,
			color: 'primary',
			timeout: 0
		},
		table: {
			params: {
				currency: null,
				search: null,
				limit: 20,
				page: 1,
				sortField: 'created_at',
				sortDirection: 'desc'
			},
			lastPage: 1,
			rows: []
		},
		inventoriesType: [{
			id: 1,
			name: 'Parcial',
			msg: null
		}, {
			id: 2,
			name: 'Completo',
			msg: {
				title: 'NOTA IMPORTANTE',
				text: 'Los productos que no aparezcan en este inventario serán actualizados con stock = 0 al momento de hacer el cierre.'
			}
		}],
		documentMessage: '',
		maxDocument: 0,
		minDocument: 0,
		personTypes: [],
		personType: {},
		personValidations: null
	};
}

function calculateLimit() {
	var footerHeight = 29;
	var headerHeight = 62;
	var rowHeight = 30;
	var usedHeight = footerHeight + headerHeight;
	var availableHeight = document.body.clientHeight - usedHeight;
	var limit = Math.ceil(availableHeight / rowHeight);
	if (limit > 20) {
		this.limit = limit;
	}
}

function setProductPrice(product, products) {
	var newProduct = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, product);
	var updateProducts = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(products));
	var selectedPriceList = newProduct.priceList[newProduct.selectedPriceListId];
	newProduct.price = this.getProductPrice(newProduct.quantity, selectedPriceList);
	if (!newProduct.price) {
		newProduct.price = product.price;
	}
	updateProducts.forEach(function (e) {
		if (e.id === newProduct.id) {
			e.price = newProduct.price;
		}
		return e;
	});
	return updateProducts;
}

function getProductPrice(quantity, priceList) {
	if (priceList.ranges.length > 0) {
		var newPrice = priceList.ranges.filter(function (el) {
			return el.from <= quantity && el.to >= quantity;
		});
		return newPrice.length > 0 ? newPrice[0].price : priceList.price;
	}
	return priceList.price;
}

function newAmountsCalculate(products, flagIgv) {
	var taxValue = 18 / 100;
	var total = 0;
	var tax = 0;
	var subtotal = products.reduce(function (acum, currentProduct) {
		return acum + currentProduct.priceList[currentProduct.selectedPriceListId].price * currentProduct.quantity;
	}, 0);
	var discount = products.reduce(function (acum, currentProduct) {
		return acum + currentProduct.discount * currentProduct.quantity;
	}, 0) || 0;
	subtotal -= discount;
	if (flagIgv === 0) {
		tax = this.roundInNumber(subtotal * taxValue);
		total = this.roundInNumber(subtotal + tax);
	} else {
		total = this.roundInNumber(subtotal);
		subtotal = this.roundInNumber(total / (1 + taxValue));
		tax = this.roundInNumber(total - subtotal);
	}
	var amounts = {
		subtotal: subtotal,
		tax: tax,
		discount: discount,
		total: total
	};
	return amounts;
}

function amountsCalculate(rows, priceListId, flagIgv, pageCode, globalDiscount) {
	var taxValue = 18 / 100;
	var total = 0;
	var tax = 0;
	var newRows = rows.map(function (row) {
		var newRow = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, row);
		if (priceListId && pageCode !== 'TNV') {
			if (row.priceList && row.priceList[priceListId]) {
				newRow.priceToSubtotal = row.priceList[priceListId].price;
				row.priceList[priceListId].ranges.forEach(function (range) {
					if (row.quantity && row.quantity > range.from - 1 && row.quantity < range.to + 1) {
						newRow.priceToSubtotal = range.price;
					}
				});
			} else if (row.product && row.product.priceList && row.product.priceList[priceListId]) {
				if (row.product.priceList[priceListId].quantity && row.quantity >= row.product.priceList[priceListId].quantity) {
					newRow.priceToSubtotal = row.product.priceList[priceListId].wholeSalePrice;
				} else {
					newRow.priceToSubtotal = row.product.priceList[priceListId].price;
				}
			} else {
				newRow.priceToSubtotal = 0;
				newRow.discount = row.discount ? row.discount : 0;
			}
		} else {
			newRow.priceToSubtotal = row.price;
		}
		return newRow;
	});
	var subtotal = newRows.reduce(function (acum, currentRow) {
		return acum + currentRow.priceToSubtotal * currentRow.quantity;
	}, 0);
	if (flagIgv === 0) {
		tax = this.roundInNumber(subtotal * taxValue);
		total = this.roundInNumber(subtotal + tax);
	} else {
		total = this.roundInNumber(subtotal);
		subtotal = this.roundInNumber(total / (1 + taxValue));
		tax = this.roundInNumber(total - subtotal);
	}
	var discount = newRows.reduce(function (acum, currentRow) {
		return acum + currentRow.discount * currentRow.quantity;
	}, 0);
	if (pageCode === 'TNV') {
		total = globalDiscount ? this.roundInNumber(subtotal + tax - globalDiscount) : this.roundInNumber(subtotal + tax);
	} else {
		total = discount ? this.roundInNumber(subtotal + tax - discount) : this.roundInNumber(subtotal + tax);
	}
	var amounts = {
		newRows: newRows,
		subtotal: subtotal,
		tax: tax,
		discount: discount,
		total: total
	};
	return amounts;
}

function brandsList() {
	return this.$httpProducts.get('brands');
}

function customersList(params) {
	return this.$httpSales.get('customers', { params: params });
}

function customerSelections(value) {
	return this.$httpSales.get('customers', { params: { search: value } });
}

function globalEmployees() {
	return this.$httpSales.get('employees');
}

function goTo(name, options) {
	switch (name) {
		case 'new-sale':
			window.open('/new-sale', '_self');
			break;
		case 'new-quotation':
			window.open('/new-quotation', '_self');
			break;
		default:
			this.$router.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({ name: name }, options));
			break;
	}
}

function warehousesList(params) {
	return this.$httpProducts.get('warehouses', { params: params });
}

function expensesList(params) {
	var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$httpSales';
	var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'expenses';

	return this[host].get(url, { params: params });
}

function typeExpensesList() {
	return this.$httpSales.get('type-expenses');
}

function subsidiariesList(params) {
	return this.$httpSales.get('subsidiaries', { params: params });
}

function massiveUploadList(params) {
	return this.$httpProducts.get('massive-upload/list', { params: params });
}
function massiveUploadRollback(id) {
	return this.$httpProducts.post('massive-upload/' + id + '/rollback');
}

function productsSelections(value) {
	var params = { search: value, noServices: 1 };
	return this.$httpProducts.get('products', { params: params });
}

function employeeSelections(value) {
	return this.$httpProduction.get('employees', { params: { search: value } });
}

function getExchangeRate() {
	return this.$httpSales.get('exchange-rate');
}

function exchangeByDate() {
	var date = this.$today;
	return this.$httpSales.get('exchange-rates/' + date);
}

function categoriesList() {
	return this.$httpProducts.get('categories');
}

function getCheckSeries(params) {
	return this.$httpSales('check-series', { params: params });
}

function getChecks(params) {
	return this.$httpSales.get('check', { params: params });
}

function getAccountType() {
	return this.$httpSales.get('bank-account-type');
}

function listOfUnits(params) {
	return this.$httpProducts.get('units', { params: params });
}

function listPricingPromise(params) {
	return this.$httpSales.get('sal-price-lists', { params: params });
}

function getPaymentsMethods() {
	return this.$httpSales.get('payments-methods');
}

function getTypePayments(type) {
	if (type) {
		var params = { flagType: type === 'sales' ? __WEBPACK_IMPORTED_MODULE_6__shared_flag_type__["a" /* default */].Sales : __WEBPACK_IMPORTED_MODULE_6__shared_flag_type__["a" /* default */].Purchases };
		return this.$httpSales.get('type-payments', { params: params });
	}
	return this.$httpSales.get('type-payments');
}

function getTypeDocuments(type) {
	if (type) {
		var params = { flagType: type === 'sales' ? __WEBPACK_IMPORTED_MODULE_6__shared_flag_type__["a" /* default */].Sales : __WEBPACK_IMPORTED_MODULE_6__shared_flag_type__["a" /* default */].Purchases };
		return this.$httpSales.get('type-documents', { params: params });
	}
	return this.$httpSales.get('type-documents');
}

function getBankAccount(id, params) {
	var url = id ? 'bank-account/' + id : 'bank-account';
	return this.$httpSales.get(url, { params: params });
}

function getBanks() {
	return this.$httpSales.get('banks');
}

function roundInNumber(value) {
	return Math.round(value * 100) / 100;
}

function showNotification(text) {
	var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'green';
	var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;

	this.$bus.$emit(__WEBPACK_IMPORTED_MODULE_8__events__["a" /* TOGGLE_SNACKBAR */], { color: color, text: text, timeout: timeout });
}

function onToggleSnackBar() {
	var _this = this;

	this.$bus.$on(__WEBPACK_IMPORTED_MODULE_8__events__["a" /* TOGGLE_SNACKBAR */], function (snackbar) {
		var newSnackbar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, snackbar);
		newSnackbar.isVisible = true;
		_this.snackbar = newSnackbar;
	});
}

function showExcelGenerateMessage() {
	var hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
	var msg = 'El excel est\xE1 siendo generado, puede revisar su estado en la secci\xF3n de ' + hrefTag;
	this.showNotification(msg, 'green', 20000);
	this.loadingExcel = false;
}

function showGenericError() {
	var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Ups, ocurrió algún problema';
	var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;

	this.showNotification(text, 'error', timeout);
}

function showRow(columns, columnId) {
	var column = columns.find(function (h) {
		return h.id === columnId;
	});
	return column.visible;
}

function selectedRows(row, currentData, dataSelected) {
	var flag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	var prop = row.warWarehouseProductBrandId ? 'warWarehouseProductBrandId' : 'id';
	var products = currentData.map(function (product) {
		var newProduct = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, product);
		var propTwo = 'location';
		if (flag) {
			if (row[prop] === newProduct[prop] && row[propTwo] === newProduct[propTwo]) {
				newProduct.isSelected = row.isSelected;
			}
		} else if (row[prop] === newProduct[prop] && row.flagFree === newProduct.flagFree) {
			newProduct.isSelected = row.isSelected;
		}
		return newProduct;
	});
	var productsSelected = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(dataSelected));
	productsSelected = this.validationToAddRow(dataSelected, prop, row, productsSelected);
	var checkAll = products.every(function (check) {
		return check.isSelected;
	});
	return { products: products, productsSelected: productsSelected, checkAll: checkAll };
}

function selecteAll(value, currentData, dataSelected) {
	var _this2 = this;

	var productsSelected = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(dataSelected));
	var products = [];
	var prop = 'id';
	if (currentData.length > 0) {
		products = currentData.map(function (dataSingle) {
			var newData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dataSingle);
			newData.isSelected = value;
			productsSelected = _this2.validationToAddRow(dataSelected, prop, newData, productsSelected);
			return newData;
		});
	}
	return { products: products, productsSelected: productsSelected, checkAll: value };
}

function goBack() {
	this.$router.back();
}

function labelsByCountry() {
	var company = this.$userInfo.company;
	var country = company.country;
	var defaultCountry = {
		id: 1,
		name: 'Perú',
		currency: 'PEN',
		code: 'PER',
		coinValue: 'Soles',
		percentage: 18,
		taxName: 'IGV',
		taxAgency: 'Sunat',
		rucLength: 11,
		subsidiaryValue: 'ruc',
		idLabel: 'Tipo de Documento'
	};
	if (country) {
		return {
			id: country.id,
			code: country.countryCode,
			currency: company.currency,
			idLabel: country.countryCode === 'PER' ? 'Tipo de Documento' : 'Identificación',
			name: country.name,
			percentage: country.countryCode === 'PER' ? country.percentage || 18 : country.percentage || 12,
			taxName: country.taxName,
			taxAgency: country.countryCode === 'PER' ? 'Sunat' : 'SRI',
			rucLength: country.countryCode === 'PER' ? 11 : 13,
			subsidiaryValue: country.countryCode === 'PER' ? 'ruc' : 'id'
		};
	}
	return defaultCountry;
}

function coinValue() {
	return this.isPeru ? 'Soles' : 'Dolares';
}

function countryCurrencySymbol() {
	return this.isPeru ? 'S/' : '$';
}

function isEcuador() {
	return this.labelsByCountry.id === 2;
}

function isPeru() {
	return this.labelsByCountry.id === 1;
}

function personType(value) {
	this.personValidations = value && value.configuration ? value.configuration.validations : value.configuration;
	if (this.personValidations) {
		this.maxDocument = this.personValidations.maxLength || 0;
		this.minDocument = this.personValidations.minLength || 0;
		if (this.maxDocument && this.minDocument) {
			if (this.maxDocument === this.minDocument) {
				this.documentMessage = 'Es necesario ingresar ' + this.minDocument + ' d\xEDgitos';
			} else {
				this.documentMessage = 'Es necesario ingresar entre ' + this.minDocument + ' y ' + this.maxDocument + ' d\xEDgitos';
			}
		} else if (this.minDocument) {
			this.documentMessage = 'Ingrese un m\xEDnimo de ' + this.minDocument + ' d\xEDgitos';
		} else if (this.maxDocument) {
			this.documentMessage = 'Ingrese un m\xE1ximo de ' + this.maxDocument + ' d\xEDgitos';
		} else {
			this.documentMessage = '';
		}
	} else {
		this.documentMessage = '';
	}
}

function openHelp(_ref11) {
	var code = _ref11.code,
	    actions = _ref11.actions;

	this.action.code = code;
	this.action.open = true;
	this.action.active = true;
	this.action.title = this.$route.meta.title;
	this.action.width = 500;
	this.actionsToHelp = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(actions));
}

function getCurrencies() {
	return this.$httpSales.get('currency');
}

function currencyByCountry(currencies) {
	return this.isEcuador ? currencies.filter(function (c) {
		return c.code === 'USD';
	}) : currencies;
}

function getCities() {
	return this.$httpSales.get('cities');
}

function stopClick() {
	return false;
}

function urlLoadData(method, code, params, id, model) {
	var url = id ? 'group/' + code + '/table/' + id : 'group/' + code + '/table';
	if (params && model) {
		return this.$httpSales[method](url, { params: params }, model);
	} else if (params) {
		return this.$httpSales[method](url, { params: params });
	} else if (model) {
		return this.$httpSales[method](url, model);
	}
	return this.$httpSales[method](url);
}

function currentWarehouseData() {
	var _$userInfo$warehouse = this.$userInfo.warehouse,
	    warehouseCodeTaxes = _$userInfo$warehouse.codeTaxes,
	    warehouseName = _$userInfo$warehouse.name;

	return { warehouseCodeTaxes: warehouseCodeTaxes, warehouseName: warehouseName };
}

function labelTerminal() {
	var plural = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	if (plural) {
		return this.isPeru ? 'Puntos de Venta' : 'Terminales';
	}
	return this.isPeru ? 'Punto de Venta' : 'Terminal';
}

function labelSucursal() {
	var plural = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	if (plural) {
		return this.isPeru ? 'Razones Sociales' : 'Sucursales';
	}
	return this.isPeru ? 'Razón Social' : 'Sucursal';
}

function labelWarehouse() {
	var plural = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	if (plural) {
		return this.isPeru ? 'Almacén' : 'Tienda';
	}
	return this.isPeru ? 'Almacenes' : 'Tiendas';
}

function validationToAddRow(itemsSelected, itemProp, item, newItemsSelected) {
	if (item.isSelected) {
		if (itemsSelected.length > 0) {
			var dataToAdd = itemsSelected.find(function (rowSelected) {
				return rowSelected[itemProp] === item[itemProp];
			});
			if (!dataToAdd) {
				newItemsSelected.push(item);
			}
		} else {
			newItemsSelected.push(item);
		}
	} else {
		var index = newItemsSelected.findIndex(function (rowData) {
			return rowData[itemProp] === item[itemProp];
		});
		newItemsSelected.splice(index, 1);
	}
	return newItemsSelected;
}

var mixin = {
	data: data,
	computed: {
		coinValue: coinValue,
		countryCurrencySymbol: countryCurrencySymbol,
		isEcuador: isEcuador,
		isPeru: isPeru,
		labelsByCountry: labelsByCountry,
		currentWarehouseData: currentWarehouseData
	},
	methods: {
		amountsCalculate: amountsCalculate,
		brandsList: brandsList,
		calculateLimit: calculateLimit,
		categoriesList: categoriesList,
		currencyByCountry: currencyByCountry,
		customersList: customersList,
		customerSelections: customerSelections,
		employeeSelections: employeeSelections,
		getExchangeRate: getExchangeRate,
		exchangeByDate: exchangeByDate,
		expensesList: expensesList,
		exportTable: exportTable,
		getAccountType: getAccountType,
		getBanks: getBanks,
		getBankAccount: getBankAccount,
		getChecks: getChecks,
		getCheckSeries: getCheckSeries,
		getCurrencies: getCurrencies,
		getCities: getCities,
		getPaymentsMethods: getPaymentsMethods,
		getProductPrice: getProductPrice,
		getTypeDocuments: getTypeDocuments,
		getTypePayments: getTypePayments,
		globalEmployees: globalEmployees,
		goBack: goBack,
		goTo: goTo,
		listPricingPromise: listPricingPromise,
		listOfUnits: listOfUnits,
		loadTypePerson: loadTypePerson,
		newAmountsCalculate: newAmountsCalculate,
		onAmortizationList: onAmortizationList,
		onPayableList: onPayableList,
		onEmitDocumentWithFormat: onEmitDocumentWithFormat,
		onEmitExcel: onEmitExcel,
		onProductList: onProductList,
		onReportSale: onReportSale,
		onToggleSnackBar: onToggleSnackBar,
		openHelp: openHelp,
		selecteAll: selecteAll,
		productsSelections: productsSelections,
		roundInNumber: roundInNumber,
		selectedRows: selectedRows,
		setProductPrice: setProductPrice,
		showExcelGenerateMessage: showExcelGenerateMessage,
		showGenericError: showGenericError,
		showNotification: showNotification,
		showRow: showRow,
		stopClick: stopClick,
		subsidiariesList: subsidiariesList,
		massiveUploadList: massiveUploadList,
		massiveUploadRollback: massiveUploadRollback,
		typeExpensesList: typeExpensesList,
		urlLoadData: urlLoadData,
		warehousesList: warehousesList,
		labelTerminal: labelTerminal,
		labelSucursal: labelSucursal,
		labelWarehouse: labelWarehouse,
		onReportSaleCommissions: onReportSaleCommissions,
		validationToAddRow: validationToAddRow
	},
	watch: {
		personType: personType
	}
};

/* harmony default export */ __webpack_exports__["a"] = (mixin);

/***/ }),
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	Sales: 1,
	Purchases: 2
});

/***/ }),
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_SNACKBAR; });
/* unused harmony export SHOW_ALERT */
var TOGGLE_SNACKBAR = 'TOGGLE_SNACKBAR';
var SHOW_ALERT = 'SHOW_ALERT';

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amortizations__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__brands__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__categories__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__check_book__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commissions__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__customers__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dashboard__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dispatch__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__features__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__guides__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__inventories__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__new_expenses__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__list_of_prices__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__list_of_transfers__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__new_client__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__new_quotation__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__new_sale__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__products__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__edit_product__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__new_product__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__project__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__quotations__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reference_guides__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__sales__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__settings__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__terminals__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__type_expenses__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__units__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__users__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__warehouses_transfer__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__warehouses__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__work__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__subsidiaries__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__edit_quotation__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__expenses__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__reports__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__bank_account__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__new_accounts_bank__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__edit_accounts_bank__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__accounting__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__cash_closing__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__countable_auxiliary__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__quipu_customers__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__test_page__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__cash_desk_closing__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__purchases__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__purchases_new__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__purchases_details__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__groups__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__suppliers__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__debts_to_pay__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__debts_to_pay_history__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__purchases_edit__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__purchases_clone__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__movements__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__bank_reconciliations__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__bank_reconciliations_history__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__documents__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__transfers_details__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__withholding__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__customers_new__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__couriers__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__customers_edit__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__payroll__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ecommerce__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__cost_center__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__control_series__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__daily_summary__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__daily_summary_create__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__new_transfers_detail__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__transfers_start__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__rating__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__questions_and_answers__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__list_of_returns__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__returns_details__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__transfers_tracking__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__field_sale__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__accounts_receivable__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__accounts_to_pay__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__zones__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__new_composite_product__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__dashboard_warehouses__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__dashboard_sale_points__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__daily_summary_detail__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__device__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__sri__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__routes__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__new_route__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__cancel_summary__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__vendors__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__new_vendor__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__cash__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__cancel_summary_detail__ = __webpack_require__(681);


































































































/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.use(__WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]);
	var config = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
		mode: 'history',
		routes: [{
			path: '/',
			name: 'admin-container',
			redirect: '/products',
			children: [__WEBPACK_IMPORTED_MODULE_42__accounting__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__amortizations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_39__bank_account__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__brands__["a" /* default */], __WEBPACK_IMPORTED_MODULE_47__cash_desk_closing__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__categories__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__check_book__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__commissions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__companies__["a" /* default */], __WEBPACK_IMPORTED_MODULE_80__components__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__customers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__dashboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_85__dashboard_warehouses__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dispatch__["a" /* default */], __WEBPACK_IMPORTED_MODULE_60__documents__["a" /* default */], __WEBPACK_IMPORTED_MODULE_41__edit_accounts_bank__["a" /* default */], __WEBPACK_IMPORTED_MODULE_36__edit_quotation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_37__expenses__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__features__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__guides__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__inventories__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__new_expenses__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__list_of_prices__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__list_of_transfers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_40__new_accounts_bank__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__new_client__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__new_quotation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_72__new_transfers_detail__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__new_sale__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__products__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__edit_product__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__new_product__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__project__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__quotations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__reference_guides__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38__reports__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__sales__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__settings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_35__subsidiaries__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__terminals__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__type_expenses__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__units__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__users__["a" /* default */], __WEBPACK_IMPORTED_MODULE_32__warehouses_transfer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_33__warehouses__["a" /* default */], __WEBPACK_IMPORTED_MODULE_62__withholding__["a" /* default */], __WEBPACK_IMPORTED_MODULE_34__work__["a" /* default */], __WEBPACK_IMPORTED_MODULE_43__cash_closing__["a" /* default */], __WEBPACK_IMPORTED_MODULE_44__countable_auxiliary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_45__quipu_customers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_46__test_page__["a" /* default */], __WEBPACK_IMPORTED_MODULE_48__purchases__["a" /* default */], __WEBPACK_IMPORTED_MODULE_49__purchases_new__["a" /* default */], __WEBPACK_IMPORTED_MODULE_56__purchases_clone__["a" /* default */], __WEBPACK_IMPORTED_MODULE_50__purchases_details__["a" /* default */], __WEBPACK_IMPORTED_MODULE_73__transfers_start__["a" /* default */], __WEBPACK_IMPORTED_MODULE_51__groups__["a" /* default */], __WEBPACK_IMPORTED_MODULE_52__suppliers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_53__debts_to_pay__["a" /* default */], __WEBPACK_IMPORTED_MODULE_54__debts_to_pay_history__["a" /* default */], __WEBPACK_IMPORTED_MODULE_55__purchases_edit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_57__movements__["a" /* default */], __WEBPACK_IMPORTED_MODULE_58__bank_reconciliations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_59__bank_reconciliations_history__["a" /* default */], __WEBPACK_IMPORTED_MODULE_61__transfers_details__["a" /* default */], __WEBPACK_IMPORTED_MODULE_63__customers_new__["a" /* default */], __WEBPACK_IMPORTED_MODULE_64__couriers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_65__customers_edit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_66__payroll__["a" /* default */], __WEBPACK_IMPORTED_MODULE_67__ecommerce__["a" /* default */], __WEBPACK_IMPORTED_MODULE_68__cost_center__["a" /* default */], __WEBPACK_IMPORTED_MODULE_69__control_series__["a" /* default */], __WEBPACK_IMPORTED_MODULE_70__daily_summary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_71__daily_summary_create__["a" /* default */], __WEBPACK_IMPORTED_MODULE_74__rating__["a" /* default */], __WEBPACK_IMPORTED_MODULE_75__questions_and_answers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_76__list_of_returns__["a" /* default */], __WEBPACK_IMPORTED_MODULE_77__returns_details__["a" /* default */], __WEBPACK_IMPORTED_MODULE_78__transfers_tracking__["a" /* default */], __WEBPACK_IMPORTED_MODULE_79__field_sale__["a" /* default */], __WEBPACK_IMPORTED_MODULE_81__accounts_receivable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_82__accounts_to_pay__["a" /* default */], __WEBPACK_IMPORTED_MODULE_83__zones__["a" /* default */], __WEBPACK_IMPORTED_MODULE_84__new_composite_product__["a" /* default */], __WEBPACK_IMPORTED_MODULE_86__dashboard_sale_points__["a" /* default */], __WEBPACK_IMPORTED_MODULE_87__daily_summary_detail__["a" /* default */], __WEBPACK_IMPORTED_MODULE_88__device__["a" /* default */], __WEBPACK_IMPORTED_MODULE_89__sri__["a" /* default */], __WEBPACK_IMPORTED_MODULE_90__routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_91__new_route__["a" /* default */], __WEBPACK_IMPORTED_MODULE_92__cancel_summary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_93__vendors__["a" /* default */], __WEBPACK_IMPORTED_MODULE_94__new_vendor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_95__cash__["a" /* default */], __WEBPACK_IMPORTED_MODULE_96__cancel_summary_detail__["a" /* default */]],
			components: {
				default: function _default() {
					return __webpack_require__.e/* import() */(140).then(__webpack_require__.bind(null, 869));
				}
			}
		}, __WEBPACK_IMPORTED_MODULE_1__login__["a" /* default */]]
	});
	config.beforeEach(function (to, from, next) {
		if (to.name !== 'list-of-transfers' && to.name !== 'pages-transfers-detail' && to.name !== 'pages-transfers-tracking') {
			localStorage.removeItem("admin" + '::filter-transfers');
		}
		if (to.meta) {
			var sidebar = JSON.parse(window.localStorage.getItem("admin" + '::sidebar'));
			if (sidebar) {
				var currentRoute = void 0;
				sidebar.forEach(function (item) {
					if (!currentRoute) {
						currentRoute = item.resource.data.find(function (r) {
							return r.uri === to.name;
						});
					}
				});
				var title = currentRoute ? currentRoute.title : to.meta.title;
				window.document.title = title;
				/* eslint-disable no-param-reassign */
				to.meta.title = title;
			}
		}
		if (to.name !== 'login') {
			var token = window.localStorage.getItem("admin" + '::token');
			if (token) {
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});
	return config;
});

/***/ }),
/* 585 */,
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/login',
	name: 'login',
	meta: {
		title: 'TANDIA'
	},
	components: {
		login: function login() {
			return __webpack_require__.e/* import() */(177).then(__webpack_require__.bind(null, 690));
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'amortizations',
	path: 'amortizations',
	redirect: '/amortizations/list',
	component: function component() {
		return __webpack_require__.e/* import() */(204).then(__webpack_require__.bind(null, 691));
	},
	children: [{
		name: 'amortizations-list',
		path: 'list',
		meta: {
			title: 'Amortizaciones'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 692));
		}
	}, {
		name: 'amortizations-history',
		path: 'history',
		meta: {
			title: 'Historial de Amortizaciones'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 693));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'brands',
	path: 'brands',
	meta: {
		title: 'Marcas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 694));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'categories',
	path: 'categories',
	meta: {
		title: 'Categorías'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 695));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'page-check-book',
	path: 'bank-accounts/check-book',
	redirect: '/bank-accounts/:bankAccountId/check-book',
	component: function component() {
		return __webpack_require__.e/* import() */(194).then(__webpack_require__.bind(null, 696));
	},
	children: [{
		name: 'check-book',
		path: '/bank-accounts/:bankAccountId/check-book',
		meta: {
			title: 'BANCO / CUENTAS BANCARIAS / CHEQUERAS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 697));
		},
		props: true
	}, {
		name: 'check',
		path: '/bank-accounts/:bankAccountId/check-book/:checkBookId/check',
		meta: {
			title: 'BANCO / CUENTAS BANCARIAS / CHEQUERAS / CHEQUES'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 698));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'commissions',
	path: 'commissions',
	component: function component() {
		return __webpack_require__.e/* import() */(187).then(__webpack_require__.bind(null, 699));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'companies',
	path: 'company',
	meta: {
		title: 'CONFIGURACIÓN DE EMPRESA'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 700));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'customers',
	path: 'customers',
	meta: {
		title: 'Clientes'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 701));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'dashboard',
	path: 'dashboard',
	meta: {
		title: 'Dashboard'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 702));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'dispatch-transfers',
	path: 'dispatch',
	meta: {
		title: 'DESPACHO'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 226));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	meta: {
		title: 'CARACTERÍSTICAS'
	},
	name: 'features',
	path: 'features',
	component: function component() {
		return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 703));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'guides',
	path: 'guides',
	component: function component() {
		return __webpack_require__.e/* import() */(189).then(__webpack_require__.bind(null, 704));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'inventories',
	path: 'inventories',
	redirect: '/inventories/list',
	component: function component() {
		return __webpack_require__.e/* import() */(203).then(__webpack_require__.bind(null, 705));
	},
	children: [{
		name: 'list-kardex-gen',
		path: 'kardex-general',
		meta: {
			title: 'Listado de Kardex General'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 706));
		}
	}, {
		name: 'list-of-inventories',
		path: 'list',
		meta: {
			title: 'INVENTARIOS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(155).then(__webpack_require__.bind(null, 707));
		}
	}, {
		name: 'new-inventory',
		path: 'new',
		props: true,
		meta: {
			title: 'INVENTARIADO NUEVO'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 708));
		}
	}, {
		name: 'inventory-detail',
		path: ':inventoryId/detail',
		props: true,
		meta: {
			title: 'DETALLE DE INVENTARIO'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(156).then(__webpack_require__.bind(null, 709));
		}
	}, {
		name: 'kardex',
		path: '/:code/:productId/:warehouseId/:brandId/kardex',
		props: true,
		meta: {
			title: 'LISTADO DE KARDEX'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(123).then(__webpack_require__.bind(null, 710));
		}
	}, {
		name: 'master-inventory',
		path: 'list-master',
		props: true,
		meta: {
			title: 'LISTADO DE INVENTARIOS MAESTROS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 711));
		}
	}, {
		name: 'child-inventory',
		path: ':id/list-child',
		props: true,
		meta: {
			title: 'LISTADO DE INVENTARIOS HIJOS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 712));
		}
	}, {
		name: 'detail-child-inventory',
		path: ':id/detail-child',
		props: true,
		meta: {
			title: 'DETALLE DE INVENTARIO HIJO'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(145).then(__webpack_require__.bind(null, 713));
		}
	}, {
		name: 'detail-master-inventory',
		path: ':id/detail-master',
		props: true,
		meta: {
			title: 'DETALLE DE INVENTARIO MAESTRO'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 714));
		}
	}, {
		name: 'summary-inventory-category',
		path: ':id/summary-category',
		props: true,
		meta: {
			title: 'RESUMEN DE INVENTARIO POR CATEGORÍA'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(146).then(__webpack_require__.bind(null, 715));
		}
	}, {
		name: 'page-new-kardex',
		path: ':productId/:warehouseId/:brandId/new-kardex',
		props: true,
		meta: {
			title: 'LISTADO DE KARDEX'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 716));
		}
	}, {
		name: 'group-inventory',
		path: 'list-groups',
		props: true,
		meta: {
			title: 'Grupos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(134).then(__webpack_require__.bind(null, 717));
		}
	}, {
		name: 'group-inventory-new',
		path: 'new-group',
		props: true,
		meta: {
			title: 'Nuevo Grupo'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(16/* duplicate */).then(__webpack_require__.bind(null, 227));
		}
	}, {
		name: 'new-entry',
		path: 'new-entry',
		props: true,
		meta: {
			title: 'Nuevo Ingreso'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 228));
		}
	}, {
		name: 'new-discharge',
		path: 'new-discharge',
		props: true,
		meta: {
			title: 'Nuevo Egreso'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 228));
		}
	}, {
		name: 'group-inventory-edit',
		path: ':id/edit-group',
		props: true,
		meta: {
			title: 'Editar Grupo'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(16/* duplicate */).then(__webpack_require__.bind(null, 227));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'new-expenses',
	path: '/expenses/new',
	meta: {
		title: 'Nuevo Gasto'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(18/* duplicate */).then(__webpack_require__.bind(null, 229));
	},
	props: true,
	children: [{
		name: 'edit-expense',
		path: ':id/edit',
		meta: {
			title: 'Edición de Gasto'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(18/* duplicate */).then(__webpack_require__.bind(null, 229));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'list-of-prices',
	path: 'list-of-prices',
	component: function component() {
		return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 718));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'list-of-transfers',
	path: '/transfers',
	meta: {
		title: 'LISTA DE TRANSFERENCIAS'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 226));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'new-client',
	path: 'new-client',
	component: function component() {
		return __webpack_require__.e/* import() */(197).then(__webpack_require__.bind(null, 719));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'new-quotation',
	path: '/new-quotation',
	meta: {
		title: 'Cotización'
	},
	// component: () => import('@/components/quotation/new-quotation'),
	component: function component() {
		return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 50));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'new-sale',
	path: 'new-sale',
	meta: {
		title: 'NUEVA VENTA'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 50));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'products',
	path: '/products',
	redirect: '/products/list',
	component: function component() {
		return __webpack_require__.e/* import() */(188).then(__webpack_require__.bind(null, 720));
	},
	children: [{
		name: 'list-of-products',
		path: 'list',
		meta: {
			title: 'PRODUCTOS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 721));
		}
	}, {
		name: 'products-movement',
		path: 'movement',
		meta: {
			title: 'MODIFICAR STOCK'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 722));
		}
	}, {
		name: 'massive-upload',
		path: 'massive-upload',
		meta: {
			title: 'PRODUCTOS CARGA MASIVA'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(164).then(__webpack_require__.bind(null, 723));
		}
	}, {
		name: 'new-massive-upload',
		path: 'new-massive-upload',
		meta: {
			title: 'PRODUCTOS CARGA MASIVA'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(170).then(__webpack_require__.bind(null, 724));
		}
	}, {
		name: 'edit-massive-upload',
		path: 'edit-massive-upload',
		meta: {
			title: 'PRODUCTOS EDICIÓN MASIVA'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(171).then(__webpack_require__.bind(null, 725));
		}
	}, {
		name: 'products-history',
		path: 'history',
		meta: {
			title: 'LISTA DE INGRESOS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(154).then(__webpack_require__.bind(null, 726));
		}
	}, {
		name: 'products-dispatch',
		path: 'dispatch',
		meta: {
			title: 'DESPACHO DE PRODUCTOS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(152).then(__webpack_require__.bind(null, 727));
		}
	}, {
		name: 'dispatch-detail',
		path: 'dispatch/:id/detail',
		meta: {
			title: 'PRODUCTOS POR ENTREGAR'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(165).then(__webpack_require__.bind(null, 728));
		}
	}, {
		name: 'min-stock',
		path: 'warehouse/:id/min-stock',
		meta: {
			title: 'PRODUCTOS CON STOCK MÍNIMO POR ALMACÉN'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(153).then(__webpack_require__.bind(null, 729));
		}
	}, {
		name: 'sale-create',
		path: '/transfers/:id/new-sale',
		meta: {
			title: 'NUEVA VENTA DE TRANSFERENCIA'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(136).then(__webpack_require__.bind(null, 730));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'edit-product',
	path: 'product/edit/:id/:warehouseId/:brandId',
	meta: {
		title: 'Editar Producto'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 230));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'new-product',
	path: 'new-product',
	meta: {
		title: 'Nuevo Producto'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 230));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'project',
	path: '/project',
	redirect: '/project/list',
	component: function component() {
		return __webpack_require__.e/* import() */(202).then(__webpack_require__.bind(null, 731));
	},
	children: [{
		name: 'request-list',
		path: 'request-list',
		meta: {
			title: 'REQUERIMIENTOS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 732));
		}
	}, {
		name: 'requirement-new',
		path: 'requirement/new',
		meta: {
			title: 'REQUERIMIENTO NUEVO'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(15/* duplicate */).then(__webpack_require__.bind(null, 231));
		}
	}, {
		name: 'edit-requirement',
		path: 'requirement/:id',
		meta: {
			title: 'EDITAR REQUERIMIENTO'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(15/* duplicate */).then(__webpack_require__.bind(null, 231));
		}
	}, {
		name: 'list-of-projects',
		path: 'list',
		meta: {
			title: 'Proyectos - Operaciones'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(19/* duplicate */).then(__webpack_require__.bind(null, 232));
		}
	}, {
		name: 'list-of-projects-op',
		path: 'list/op',
		meta: {
			title: 'Proyectos - Operaciones'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(19/* duplicate */).then(__webpack_require__.bind(null, 232));
		}
	}, {
		name: 'list-of-quotations',
		path: 'quotations',
		meta: {
			title: 'Proyectos - Cotizaciones'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(151).then(__webpack_require__.bind(null, 733));
		}
	}, {
		name: 'calendar-by-project',
		path: 'calendar/:projectId',
		meta: {
			title: 'Proyectos - Operaciones'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(132).then(__webpack_require__.bind(null, 734));
		}
	}, {
		name: 'employees',
		path: 'employees',
		meta: {
			title: 'Listado de Técnicos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 735));
		}
	}, {
		name: 'project-movements',
		path: 'project/:id-:autoCode/movements/:saleId',
		meta: {
			title: 'Movimientos de Productos'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(135).then(__webpack_require__.bind(null, 736));
		}
	}, {
		name: 'project-transfer',
		path: 'project/:id-:autoCode/transfer/new/:type/:saleId',
		meta: {
			title: 'Ingreso/Salida de Productos'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(150).then(__webpack_require__.bind(null, 737));
		}
	}, {
		name: 'requirement-types',
		path: 'requirement-types',
		meta: {
			title: 'Tipos de Requerimiento'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 738));
		}
	}, {
		name: 'oit-edit',
		path: ':id/edit',
		props: true,
		meta: {
			title: 'Editar OIT'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(163).then(__webpack_require__.bind(null, 739));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'quotations',
	path: 'quotations',
	meta: {
		title: 'Cotización'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(186).then(__webpack_require__.bind(null, 740));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'reference-guides',
	path: '/reference-guides',
	redirect: '/reference-guides/list',
	component: function component() {
		return __webpack_require__.e/* import() */(201).then(__webpack_require__.bind(null, 741));
	},
	children: [{
		name: 'list-of-guides',
		path: 'list',
		meta: {
			title: 'GUÍAS DE REMISIÓN'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 742));
		}
	}, {
		name: 'reference-guide-detail',
		path: ':id?/detail/:saleId?',
		meta: {
			title: 'GUÍA DE REMISIÓN'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 743));
		}
	}, {
		name: 'reference-guide-view',
		path: ':id?/view',
		meta: {
			title: 'DETALLE GUÍA DE REMISIÓN'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 744));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'sales',
	path: '/sales',
	redirect: '/sales/list',
	component: function component() {
		return __webpack_require__.e/* import() */(199).then(__webpack_require__.bind(null, 745));
	},
	children: [{
		name: 'transform-sale',
		path: 'transform/:id/:origin/:currency',
		props: true,
		meta: {
			title: 'TRANSFORMACIÓN A VENTA'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 50));
		}
	}, {
		name: 'clone-sale',
		path: 'clone/:id/:currency',
		props: true,
		meta: {
			title: 'CLONACIÓN DE VENTA'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 50));
		}
	}, {
		name: 'clone-quotization',
		path: 'clone/quotation/:id/:currency',
		props: true,
		meta: {
			title: 'CLONACIÓN DE COTIZACIÓN'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 50));
		}
		// component: () => import('@/components/quotation/new-quotation'),
	}, {
		name: 'list-of-sales',
		path: 'list',
		meta: {
			title: 'LISTA DE VENTAS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 67));
		}
	}, {
		name: 'quotations-list',
		path: 'quotation/list',
		meta: {
			title: 'LISTA DE COTIZACIONES'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 67));
		}
	}, {
		name: 'sale-detail',
		path: ':saleId/detail',
		props: true,
		meta: {
			title: 'DETALLE DE VENTA'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 746));
		}
	}, {
		name: 'sales-closed',
		path: 'closed',
		meta: {
			title: 'CIERRE DE CAJAS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(148).then(__webpack_require__.bind(null, 747));
		}
	}, {
		name: 'sales-closed-detail',
		path: 'closed-detail',
		meta: {
			title: 'DETALLE DE CAJA'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(149).then(__webpack_require__.bind(null, 748));
		}
	}, {
		name: 'convert',
		path: 'convert/:id',
		meta: {
			title: 'DETALLE DE VENTA'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 749));
		}
	}, {
		name: 'sales-cash-closing',
		path: 'cash-closing',
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(175).then(__webpack_require__.bind(null, 750));
		}
	}, {
		name: 'commissions-for-sale',
		path: 'commissions',
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(129).then(__webpack_require__.bind(null, 751));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'settings',
	path: 'settings',
	component: function component() {
		return __webpack_require__.e/* import() */(185).then(__webpack_require__.bind(null, 752));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'terminals',
	path: 'terminals',
	meta: {
		title: 'Lista de Terminales'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(119).then(__webpack_require__.bind(null, 753));
	},
	children: [{
		name: 'terminals-new',
		path: 'new',
		meta: {
			title: 'Lista de Terminales'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(14/* duplicate */).then(__webpack_require__.bind(null, 233));
		}
	}, {
		name: 'terminals-edit',
		path: ':id/edit',
		meta: {
			title: 'Lista de Terminales'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(14/* duplicate */).then(__webpack_require__.bind(null, 233));
		}
	}, {
		name: 'terminals-delete',
		path: ':id/delete',
		meta: {
			title: 'Lista de Terminales'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(166).then(__webpack_require__.bind(null, 754));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'type-expenses',
	path: 'type',
	component: function component() {
		return __webpack_require__.e/* import() */(191).then(__webpack_require__.bind(null, 755));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'units',
	path: 'units',
	meta: {
		title: 'Unidades'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 756));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'users',
	path: 'users',
	redirect: '/users/list',
	component: function component() {
		return __webpack_require__.e/* import() */(196).then(__webpack_require__.bind(null, 757));
	},
	children: [{
		name: 'users-list',
		path: 'list',
		meta: {
			title: 'Usuarios'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 758));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'warehouses-transfer',
	path: 'transfer',
	component: function component() {
		return __webpack_require__.e/* import() */(190).then(__webpack_require__.bind(null, 759));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'warehouses',
	path: 'warehouses',
	meta: {
		title: 'NUEVA TIENDA'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 760));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'work',
	path: 'work',
	meta: {
		title: 'ORDEN INTERNA DE TRABAJO'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(147).then(__webpack_require__.bind(null, 761));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'subsidiaries',
	path: 'subsidiaries',
	meta: {
		title: 'NUEVA SUCURSAL'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 762));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'edit-quotation',
	path: 'quotation/:id',
	meta: {
		title: 'Editar cotización'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 763));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'expenses',
	path: '/expenses',
	meta: {
		title: 'GASTOS'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 764));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'reports',
	path: '/reports',
	redirect: '/reports/list',
	component: function component() {
		return __webpack_require__.e/* import() */(200).then(__webpack_require__.bind(null, 765));
	},
	children: [{
		name: 'reports-list',
		path: '/reports/list',
		meta: {
			title: 'Reportes'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(139).then(__webpack_require__.bind(null, 766));
		}
	}, {
		name: 'report-in-out',
		path: '/reports/in/out',
		meta: {
			title: 'Reporte IN/OUT'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(120).then(__webpack_require__.bind(null, 767));
		}
	}, {
		name: 'utilities-by-warehouse',
		path: '/reports/utilities-by-warehouse',
		meta: {
			title: 'Reporte de Utilidades por Tienda'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 768));
		}
	}, {
		name: 'rotation-report',
		path: '/reports/rotation',
		meta: {
			title: 'Reporte de Rotación'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 769));
		}
	}, {
		name: 'reports-transfers-detail',
		path: '/reports/transfer-detail',
		meta: {
			title: 'REPORTE DE PRODUCTOS DEVUELTOS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 770));
		}
	}, {
		name: 'sales-category',
		path: '/reports/sales-category',
		component: function component() {
			return __webpack_require__.e/* import() */(130).then(__webpack_require__.bind(null, 771));
		},
		meta: {
			title: 'Reporte de Venta por Categoría'
		}
	}, {
		name: 'detail-report-category',
		path: '/reports/detail-sales-category/:id?',
		meta: {
			title: 'Detalle de la Categoría'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(162).then(__webpack_require__.bind(null, 772));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'bank-accounts',
	path: 'bank-accounts',
	meta: {
		title: 'LISTA DE CUENTAS BANCARIAS'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 773));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'new-account-bank',
	path: 'new-account-bank',
	component: function component() {
		return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 234));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'edit-account-bank',
	path: 'edit-account-bank/:id',
	meta: {
		title: 'Editando cuenta bancaria'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 234));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'accounting',
	path: 'accounting',
	redirect: '/accounting/list',
	component: function component() {
		return __webpack_require__.e/* import() */(205).then(__webpack_require__.bind(null, 774));
	},
	children: [{
		name: 'accounting-products-list',
		path: 'list',
		meta: {
			title: 'Contabilidad - Listado de productos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(117).then(__webpack_require__.bind(null, 775));
		}
	}, {
		name: 'accounting-new-product',
		path: 'new-product/:route?',
		meta: {
			title: 'Nuevo producto'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 235));
		}
	}, {
		name: 'accounting-edit-product',
		path: 'accounting-edit-product/:id/:route?',
		meta: {
			title: 'Editar producto'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 235));
		}
	}, {
		name: 'composition-products',
		path: 'composition-products',
		meta: {
			title: 'Composición de productos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 236));
		}
	}, {
		name: 'edit-composition-products',
		path: 'edit-composition-products/:id',
		meta: {
			title: 'Edición de producto combo'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 236));
		}
	}, {
		name: 'accounting-taxes',
		path: 'accounting-taxes',
		meta: {
			title: 'Contabilidad'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 776));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'cash-closing',
	path: 'cash-closing',
	meta: {
		title: 'Cierre de Caja'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(176).then(__webpack_require__.bind(null, 777));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'countable-auxiliary',
	path: 'countable-auxiliary',
	meta: {
		title: 'Auxilares Contables'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 778));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'quipu-customers',
	path: 'quipu/customers',
	meta: {
		title: 'Clientes'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 779));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'test-page',
	path: '/test',
	meta: {
		title: 'Prueba'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(160).then(__webpack_require__.bind(null, 780));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'main-cash-desk-closing',
	path: 'cash-desk-closing',
	redirect: 'cash-desk-closing/list',
	component: function component() {
		return __webpack_require__.e/* import() */(178).then(__webpack_require__.bind(null, 781));
	},
	children: [{
		name: 'cash-desk-closing-list',
		path: 'list',
		meta: {
			title: 'Cajas'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 782));
		}
	}, {
		name: 'cash-desk-closing-movement',
		path: 'movement/:id',
		meta: {
			title: 'Arqueo de Caja'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 783));
		}
	}, {
		name: 'cash-desk-closing-transactions',
		path: 'transactions/:salCashDeskClosingId?/:cashId?',
		meta: {
			title: 'Movimiento de Caja'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 784));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'purchases',
	path: '/purchases',
	meta: {
		title: 'Compras'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 785));
	}
	// children: [
	// 	{
	// 		name: 'debts-to-pay-history',
	// 		path: 'debts-to-pay-history',
	// 		meta: {
	// 			title: 'Historial de cuentas por pagar',
	// 		},
	// 		component: () => import('@/components/purchases/debts-to-pay-history'),
	// 	},
	// ],
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'purchases-new',
	path: '/purchases/new',
	meta: {
		title: 'Nueva Compra'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 113));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'purchases-details',
	path: '/purchases/:id/details',
	meta: {
		title: 'Detalle de Compra'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(158).then(__webpack_require__.bind(null, 786));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'groups',
	path: 'groups',
	meta: {
		title: 'GRUPOS'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(122).then(__webpack_require__.bind(null, 787));
	},
	children: [{
		name: 'groups-new',
		path: ':typeEntityId/new',
		meta: {
			title: 'Nuevo Grupo'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(17/* duplicate */).then(__webpack_require__.bind(null, 237));
		}
	}, {
		name: 'groups-edit',
		path: ':id/edit',
		meta: {
			title: 'Editar Grupo'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(17/* duplicate */).then(__webpack_require__.bind(null, 237));
		}
	}, {
		name: 'groups-delete',
		path: ':id/:name/delete',
		meta: {
			title: 'Eliminar Grupo'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(168).then(__webpack_require__.bind(null, 788));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'suppliers',
	path: '/suppliers',
	meta: {
		title: 'Proveedores'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 789));
	},
	children: [{
		name: 'suppliers-new',
		path: 'new',
		meta: {
			title: 'Nuevo Proveedor'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, 238));
		}
	}, {
		name: 'suppliers-edit',
		path: ':id/edit',
		meta: {
			title: 'Editar Proveedor'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, 238));
		}
	}, {
		name: 'suppliers-delete',
		path: ':id/delete',
		meta: {
			title: 'Eliminar Proveedor'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(167).then(__webpack_require__.bind(null, 790));
		}
	}, {
		name: 'suppliers-group',
		path: '/group/new',
		meta: {
			title: 'Proveedores'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(128).then(__webpack_require__.bind(null, 791));
		}
	}, {
		name: 'suppliers-purchases-details',
		path: ':id/purchases/details',
		meta: {
			title: 'Proveedores'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(141).then(__webpack_require__.bind(null, 792));
		}
	}, {
		name: 'suppliers-total',
		path: ':id/:type/total',
		meta: {
			title: 'Proveedores'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(172).then(__webpack_require__.bind(null, 793));
		}
	}, {
		name: 'suppliers-documents',
		path: ':id/documents',
		meta: {
			title: 'Documentos'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(169).then(__webpack_require__.bind(null, 794));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'debts-to-pay',
	path: '/debts-to-pay',
	meta: {
		title: 'Cuentas por Pagar'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 795));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'debts-to-pay-history',
	path: '/debts-to-pay-history',
	meta: {
		title: 'Cuentas por Pagar'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 796));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'purchases-edit',
	path: '/purchases/:id/edit',
	props: true,
	meta: {
		title: 'Editar Compra'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 113));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'purchases-clone',
	path: '/purchases/:id/clone',
	props: true,
	meta: {
		title: 'Clonar Compra'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 113));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'bank-movements',
	path: 'bank-movements',
	meta: {
		title: 'Movimientos de Banco'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 797));
	},
	children: [{
		name: 'bank-movements-new',
		path: 'new',
		meta: {
			title: 'Movimientos de Banco'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(126).then(__webpack_require__.bind(null, 798));
		}
	}, {
		name: 'bank-to-bank',
		path: 'transfer',
		meta: {
			title: 'Movimientos de Banco'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(125).then(__webpack_require__.bind(null, 799));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'bank-reconciliations',
	path: '/bank-reconciliations',
	meta: {
		title: 'Conciliación Bancaria'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 800));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'bank-reconciliations-history',
	path: '/bank-reconciliations/history',
	meta: {
		title: 'Historial de Conciliaciones'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(161).then(__webpack_require__.bind(null, 801));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'documents',
	path: '/documents',
	component: function component() {
		return __webpack_require__.e/* import() */(142).then(__webpack_require__.bind(null, 802));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'pages-transfers-detail',
	path: '/transfers/:id/detail',
	meta: {
		title: 'LISTA DE PRODUCTOS DE LA TRANSFERENCIA'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, 803));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'withholding-list',
	path: '/withholding',
	meta: {
		title: 'Retenciones'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(118).then(__webpack_require__.bind(null, 804));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'customers-new',
	path: '/customers/new',
	meta: {
		title: 'Nuevo Cliente'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 239));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'pages-couriers-list',
	path: '/couriers',
	meta: {
		title: 'Transportistas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 805));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'customers-edit',
	path: '/customers/:id/edit',
	meta: {
		title: 'Editar Cliente'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 239));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'payroll',
	path: 'payroll',
	redirect: '',
	component: function component() {
		return __webpack_require__.e/* import() */(192).then(__webpack_require__.bind(null, 806));
	},
	children: [{
		name: 'working-relationship',
		path: ':id?/:code?/working-relationship',
		meta: {
			title: 'Relacion de Trabajo'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 807));
		},
		props: true
	}, {
		name: 'call-attention',
		path: ':id?/call-attention',
		meta: {
			title: 'Llamadas Atención'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 808));
		},
		props: true
	}, {
		name: 'type-of-employer',
		path: ':id?type-of-employer',
		meta: {
			title: 'Tipos de Empleador'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 809));
		},
		props: true
	}, {
		name: 'cargo-type',
		path: ':id?/type-position',
		meta: {
			title: 'Tipo de Personal / Tipos de Cargo'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 810));
		},
		props: true
	}, {
		name: 'type-of-personnel',
		path: 'type-person',
		meta: {
			title: 'Tipos de Personal'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 811));
		},
		props: true
	}, {
		name: 'relatives',
		path: ':id?/family-employee',
		meta: {
			title: 'Control de Empleado Familia'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 812));
		},
		props: true
	}, {
		name: 'remuneration',
		path: 'remuneration',
		meta: {
			title: 'Tipo de Remuneración'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 813));
		},
		props: true
	}, {
		name: 'employee-control',
		path: 'employee-control',
		meta: {
			title: 'Control de Empleados'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(116).then(__webpack_require__.bind(null, 814));
		},
		props: true
	}, {
		name: 'control-date-employee',
		path: ':id/control-date-employee',
		meta: {
			title: 'CONTROL DE FECHAS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 815));
		},
		props: true
	}, {
		name: 'additional-data-employee',
		path: ':id?/additional-data',
		meta: {
			title: 'Datos Adicionales'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 816));
		},
		props: true
	}, {
		name: 'employee-create',
		path: ':id?/employee-create',
		meta: {
			title: 'Crear Empleado'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 817));
		},
		props: true
	}, {
		name: 'appreciation',
		path: ':id/appreciation',
		meta: {
			title: 'RECONOCIMIENTO'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 818));
		},
		props: true
	}, {
		name: 'type-of-employee',
		path: 'type-employee',
		meta: {
			title: 'Tipo de Empleado'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 819));
		}
	}, {
		name: 'areas',
		path: 'areas',
		meta: {
			title: 'Áreas'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 820));
		},
		props: true
	}, {
		name: 'costs-control',
		path: 'costs-control',
		meta: {
			title: 'Centro de Costos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 821));
		}
	}, {
		name: 'concept',
		path: 'concept',
		meta: {
			title: 'Rubros'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(121).then(__webpack_require__.bind(null, 822));
		}
	}, {
		name: 'new-concept',
		path: ':id?/new-concept',
		meta: {
			title: 'Nuevo Rubro'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 823));
		},
		props: true
	}, {
		name: 'role-of-payments',
		path: 'role-of-payments',
		meta: {
			title: 'Rol de Pagos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 824));
		},
		props: true
	}, {
		name: 'role-of-payments-details',
		path: ':id?/role-of-payments-details',
		meta: {
			title: 'Detalle de Rol de Pagos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(159).then(__webpack_require__.bind(null, 825));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'ecommerce',
	path: '/ecommerce',
	component: function component() {
		return __webpack_require__.e/* import() */(193).then(__webpack_require__.bind(null, 826));
	},
	children: [{
		name: 'orders',
		path: 'orders',
		meta: {
			title: 'Pedidos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 827));
		}
	}, {
		name: 'banner',
		path: 'banner',
		meta: {
			title: 'Banners'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(124).then(__webpack_require__.bind(null, 828));
		}
	}, {
		name: 'new-banner',
		path: 'new-banner',
		meta: {
			title: 'Crear Banners'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 240));
		}
	}, {
		name: 'edit-banner',
		path: ':id/edit-banner',
		meta: {
			title: 'Editar Banners'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 240));
		}
	}, {
		name: 'products-ecommerce',
		path: 'products',
		meta: {
			title: 'Productos Ecommerce'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 829));
		}
	}, {
		name: 'create-product',
		path: 'products/new',
		meta: {
			title: 'Nuevo Producto'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 241));
		}
	}, {
		name: 'edit-product-ecommerce',
		path: 'products/:id/edit',
		meta: {
			title: 'Editar Producto'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 241));
		},
		props: true
	}, {
		name: 'filters',
		path: 'filters',
		meta: {
			title: 'Filtros'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 830));
		}
	}, {
		name: 'product-sections',
		path: 'products-sections',
		meta: {
			title: 'SECCIONES DE PRODUCTOS'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 831));
		}
	}, {
		name: 'categories-ecommerce',
		path: 'categories',
		meta: {
			title: 'Categorías'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 832));
		}
	}, {
		name: 'edit-order',
		path: 'order/:id/edit',
		meta: {
			title: 'Editar pedido'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 833));
		}
	}, {
		name: 'configuration',
		path: 'configuration/:id',
		meta: {
			title: 'Configuración'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 834));
		}
	}, {
		name: 'cost-of-shipping',
		path: 'cost-of-shipping',
		meta: {
			title: 'Costo de Envío'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 835));
		}
	}, {
		name: 'commerce',
		path: 'commerce',
		meta: {
			title: 'Comercio'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 836));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'cost-centers',
	path: '/cost-centers',
	meta: {
		title: 'Centros de Costos'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 837));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'series-control',
	path: 'series-control',
	meta: {
		title: 'Control de Series'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 838));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'daily-summary',
	path: 'daily-summary',
	meta: {
		title: 'Lista de Resumen Diario de Boletas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 242));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'daily-summary-create',
	path: 'daily-summary/new',
	meta: {
		title: 'Enviar Resumen Diario de Boletas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 839));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'page-new-transfers-detail',
	path: '/new-transfers-detail',
	meta: {
		title: 'Movimiento de Producto'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(173).then(__webpack_require__.bind(null, 840));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'page-transfers-start',
	path: '/transfers/:id/start',
	meta: {
		title: 'LISTA DE PRODUCTOS DE LA TRANSFERENCIA'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(144).then(__webpack_require__.bind(null, 841));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'rating',
	path: 'rating',
	meta: {
		title: 'VALORACIÓN'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 842));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'questions-and-answers',
	path: 'questions-and-answers',
	meta: {
		title: 'PREGUNTAS Y RESPUESTAS'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 843));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'list-of-returns',
	path: '/returns',
	meta: {
		title: 'DEVOLUCIONES'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 844));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'pages-returns-detail',
	path: '/returns/:id/detail',
	meta: {
		title: 'LISTA DE PRODUCTOS DE LA TRANSFERENCIA'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(143).then(__webpack_require__.bind(null, 845));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'pages-transfers-tracking',
	path: '/transfers/:id/tracking',
	meta: {
		title: 'MOVIMIENTO DE PRODUCTO'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(174).then(__webpack_require__.bind(null, 846));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	meta: {
		title: 'Venta de Campo'
	},
	name: 'field-sale',
	path: '/field-sale',
	redirect: 'zone-assignment',
	component: function component() {
		return __webpack_require__.e/* import() */(179).then(__webpack_require__.bind(null, 847));
	},
	children: [{
		meta: {
			title: 'ASIGNAR ZONA'
		},
		name: 'page-zone-assignment',
		path: 'zone-assignment',
		component: function component() {
			return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 848));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'components',
	path: 'components',
	meta: {
		title: 'Componentes'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 849));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'accounts-receivable',
	path: 'accounts-receivable',
	meta: {
		title: 'CUENTAS POR COBRAR'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 850));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'accounts-to-pay',
	path: 'accounts-to-pay',
	meta: {
		title: 'CUENTAS POR PAGAR'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 851));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'zones',
	path: 'zones',
	meta: {
		title: 'Zonas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(133).then(__webpack_require__.bind(null, 852));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'page-composite-products-new',
	path: '/composite-products/new',
	meta: {
		title: 'Nuevo Producto Compuesto'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 853));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'dashboard-warehouses',
	path: 'dashboard/:id/:subsidiaryName',
	meta: {
		title: 'Dashboard'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, 854));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'dashboard-sale-points',
	path: 'dashboard/:subsidiaryId/:subsidiaryName/:warehouseId/:warehouseName',
	meta: {
		title: 'Dashboard'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 855));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'daily-summary-detail',
	path: 'daily-summary/:ballotSummaryId/detail',
	meta: {
		title: 'Lista de Ventas'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 67));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'device',
	path: 'device',
	meta: {
		title: 'Dispositivos'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(137).then(__webpack_require__.bind(null, 856));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'import-documents',
	path: '/import-documents',
	meta: {
		title: 'Listas de archivos txt'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 857));
	},
	children: [{
		name: 'detail-import',
		path: ':id/:dateStart/:dateEnd/detail',
		meta: {
			title: 'Relación de Documentos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(138).then(__webpack_require__.bind(null, 858));
		},
		props: true,
		children: [{
			name: 'detail-purchase',
			path: ':purchaseId/detail',
			meta: {
				title: 'Detalle de Factura - # Factura'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(127).then(__webpack_require__.bind(null, 859));
			},
			props: true
		}]
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'routes',
	path: '/zones/:zoneId/:zoneName/routes',
	meta: {
		title: 'Rutas'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 860));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'new-route',
	path: '/zones/:zoneId/:zoneName/routes/new',
	meta: {
		title: 'NUEVA RUTA'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 861));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'cancel-summary',
	path: 'cancel-summary',
	meta: {
		title: 'Lista de Resumen de Documentos Anulados'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 242));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'vendors',
	path: '/field-sale/vendors',
	meta: {
		title: 'VENDEDORES'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 862));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'new-vendor',
	path: '/field-sale/vendors/new',
	meta: {
		title: 'NUEVO VENDEDOR'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 863));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'cash',
	path: '/cash',
	component: function component() {
		return __webpack_require__.e/* import() */(195).then(__webpack_require__.bind(null, 864));
	},
	children: [{
		name: 'cash-box-close',
		path: 'close',
		meta: {
			title: 'Caja'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 865));
		}
	}, {
		name: 'box-history',
		path: 'history',
		meta: {
			title: 'Historial Cierre de Caja'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(157).then(__webpack_require__.bind(null, 866));
		}
	}, {
		name: 'box-history-detail',
		path: 'history/:id/detail',
		meta: {
			title: 'Detalle de Caja'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 867));
		},
		props: true
	}, {
		name: 'box-detail',
		path: ':id/detail',
		meta: {
			title: 'Detalle de Caja'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(131).then(__webpack_require__.bind(null, 868));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	name: 'cancel-summary-detail',
	path: 'cancel-summary/:summaryUnsubscribeId/detail',
	meta: {
		title: 'Lista de Ventas'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 67));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ })
]),[243]);


// WEBPACK FOOTER //
// static/js/app.ec4b9c96b17f9e1adbee.js